export default {
    "generalErrorMessage": {
        "fieldIsRequired": "Поле обязательно для заполнения",
        "field_required": "Это поле обязательно для заполнения",
        "something_went_wrong": "Что-то пошло не так"
    },
    "authErrorMessage": {
        "emailError": "Поле электронной почты должно содержать действующий email",
        "passwordValid": "Поле пароля должно содержать хотя бы 8 символов",
        "validPassRegex": "Пароль должен содержать не менее 8 символов и включать хотя бы 1 букву, 1 заглавную букву, 1 цифру и 1 специальный символ",
        "confirmPasswordValid": "Подтверждение пароля не совпадает",
        "validCharactersfirst": "Поле имени должно содержать только буквы и пробелы",
        "validCharacterslast": "Поле фамилии должно содержать только буквы и пробелы",
        "minMust": "должно быть не менее 3 символов",
        "must_be_a_valid_email": "Должен быть действительный email",
        "currentPassword": "текущие пароли должны иметь длину не менее 8 символов и содержать как минимум 1 буквенный, 1 верхний регистр, 1 цифровой и 1 специальный символ",
        "newPassword": "новые пароли должны иметь длину не менее 8 символов и содержать не менее 1 алфавита, 1 верхнего регистра, 1 цифры и 1 специального символа",
        "currentPasswordValid": "Поле текущего пароля должно содержать не менее 8 символов",
        "newPasswordValid": "Поле нового пароля должно содержать не менее 8 символов",
        "please_wait_before_resending_email": "Пожалуйста, проверьте свою электронную почту. Если вы не получили его, вы можете повторно отправить письмо для подтверждения через 1 минуту."
    },
    "companyErrorMessage": {
        "phoneNumberValid": "Поле номера телефона должно содержать не менее 10 символов",
        "Something_went_wrong_Please_contact_to_admin": "Что-то пошло не так. Пожалуйста, свяжитесь с администратором"
    },
    "errorPage": {
        "project_name": "Название проекта",
        "project_key": "Ключ проекта",
        "project_category": "Категория проекта",
        "team_name": "Название команды",
        "The": "The",
        "field_must_be_a_valid": "Поле должно быть действительным",
        "email": "Email",
        "password": "Пароль",
        "first_name": "Имя",
        "last_name": "Фамилия",
        "company_name": "Название компании",
        "file_extension": "Расширение файла",
        "milestone_status": "Статус этапа",
        "name": "Название",
        "phone_number": "Номер телефона",
        "field_must_be_at_least": "Поле должно содержать не менее",
        "number": "Число",
        "characters": "символов",
        "digits": "Цифры",
        "priority_name": "Название приоритета",
        "firstName": "Имя",
        "lastName": "Фамилия",
        "phoneNumber": "Номер телефона",
        "amount": "Сумма",
        "phone": "Телефон",
        "country": "Страна",
        "state": "Штат",
        "city": "Город",
        "templatename": "Название шаблона",
        "description": "Описание",
        "Template_name_is_required": "Название шаблона обязательно для заполнения",
        "This_template_name_is_required.": "Это название шаблона обязательно для заполнения.",
        "status": "Статус",
        "zipcode": "Почтовый индекс",
        "address2": "Адрес 2",
        "address1": "Адрес 1",
        "The_confirm_password_field_is_required": "Поле подтверждения пароля обязательно для заполнения",
        "The_confirm_password_confirmation_does_not_match": "Подтверждение пароля не совпадает",
        "terms_and_condition": "Условия и положения",
        "category_name": "Название категории",
        "channel_name": "Название канала",
        "amount_per_hours": "Сумма за час",
        "refundamount": "Сумма возврата",
        "please_select_template": "Пожалуйста, выберите шаблон",
        "template_name_already_exists": "Название шаблона уже существует",
        "select_a_date": "Выберите дату",
        "must_be_less_than": "должно быть меньше, чем ",
        "project_duedate": "Срок выполнения проекта",
        "project_lead_assignee": "Ответственный за проект",
        "current_password": "Текущий пароль",
        "new_password": "Новый пароль",
        "confirm_password": "Подтвердите пароль",
        "This_template_name_is_already_exists": "Это название шаблона уже существует.",
        "card_name": "название карточки",
        "topic": "тема",
        "target_audience": "целевая аудитория",
        "keywords": "ключевые слова",
        "content_purpose": "цель контента",
        "product/service": "продукт/услуга",
        "campaign_goals": "цели кампании",
        "value_proposition": "ценностное предложение",
        "objectives": "задачи",
        "key_message": "ключевое сообщение",
        "problem": "проблема",
        "context": "контекст",
        "constraints": "ограничения",
        "main_keyword": "основное ключевое слово",
        "secondary_keywords": "второстепенные ключевые слова",
        "content_goal": "цель контента",
        "keyword_list": "список ключевых слов",
        "questions": "вопросы",
        "product_description": "описание продукта",
        "feedback_data": "данные обратной связи",
        "survey_questions": "вопросы опроса",
        "project": "проект",
        "progress_made": "достигнутый прогресс",
        "next_steps": "следующие шаги",
        "key_features": "ключевые особенности",
        "client_type": "тип клиента",
        "challenges": "вызовы",
        "results": "результаты",
        "event_type": "тип события",
        "cta": "призыв к действию",
        "campaign_objectives": "цели кампании",
        "survey_objectives": "цели опроса",
        "column_one_name": "название первого столбца",
        "column_two_name": "название второго столбца",
        "column_one_data": "данные первого столбца",
        "column_two_data": "данные второго столбца",
        "customer_name": "имя клиента",
        "email_purpose": "цель электронного письма",
        "talking_points": "основные моменты для обсуждения",
        "product_name": "название продукта",
        "about_the_product": "о продукте",
        "core_problem_it_solves": "основная проблема, которую он решает",
        "what_makes_it_different": "что делает его особенным",
        "the_product_is": "продукт является",
        "core_differentiators": "основные отличия",
        "product/service_benefits": "преимущества продукта/услуги",
        "call_notes": "заметки звонка",
        "call_transcript": "расшифровка звонка",
        "target_company": "целевая компания",
        "use_case": "случай использования",
        "customer_challenges": "проблемы клиента",
        "territories": "территории",
        "target_industries": "целевые отрасли",
        "sales_goals": "цели продаж",
        "sales_strategies": "стратегии продаж",
        "transcript": "расшифровка",
        "pain_points": "болевые точки",
        "company_type": "тип компании",
        "sales_cycle_stages": "этапы цикла продаж",
        "sales_methodologies": "методологии продаж",
        "key_skills": "ключевые навыки",
        "training_formats": "форматы обучения",
        "participants": "участники",
        "target_industry": "целевая отрасль",
        "value_statement": "заявление о ценности",
        "meeting_type": "тип встречи",
        "your_talking_points": "ваши основные моменты",
        "goal": "цель",
        "reasons_for_canceling": "причины отмены",
        "incentive": "стимул",
        "unique_selling_points": "уникальные торговые предложения",
        "desired_format": "желаемый формат",
        "topics": "темы",
        "content": "контент",
        "stakeholders": "заинтересованные стороны",
        "sales_notes": "заметки по продажам",
        "customer_goals": "цели клиента",
        "teams_impacted": "затронутые команды",
        "requirements": "требования",
        "goals_met": "достигнутые цели",
        "project_stakeholders": "заинтересованные стороны проекта",
        "opportunities": "возможности",
        "risks": "риски",
        "customer_message": "сообщение клиента",
        "date_range": "диапазон дат",
        "project_notes": "заметки проекта",
        "project_description": "описание проекта",
        "name_of_project": "название проекта",
        "date_ranges": "диапазоны дат",
        "requestor": "заявитель",
        "requests": "запросы",
        "reason_for_the_change": "причина изменения",
        "expected_impact_of_the_change": "ожидаемое воздействие изменения",
        "project_goals": "цели проекта",
        "participant_names": "имена участников",
        "meeting_time": "время встречи",
        "timeline": "временная шкала",
        "deliverables": "результаты поставки",
        "project_goal": "цель проекта",
        "project_scope": "область проекта",
        "main_task": "основная задача",
        "new_format": "новый формат",
        "original_text": "исходный текст",
        "stakeholder_titles": "должности заинтересованных сторон",
        "article_title": "название статьи",
        "focus_keywords": "ключевые слова фокуса",
        "title_of_the_blog_text": "заголовок текста блога",
        "blog_topic": "тема блога",
        "section_title": "название раздела",
        "section_content": "содержание раздела",
        "section": "раздел",
        "title": "заголовок",
        "title(faq_question)": "заголовок(вопрос FAQ)",
        "issue_description": "описание проблемы",
        "code_section": "раздел кода",
        "concept": "концепция",
        "version": "версия",
        "changes": "изменения",
        "job_title": "должность",
        "your_name": "ваше имя",
        "your_skills": "ваши навыки",
        "math_question": "математический вопрос",
        "question": "вопрос",
        "thesis_topic": "тема диссертации",
        "text_to_proofread": "текст для корректуры",
        "text_to_rephrase": "текст для перефразирования",
        "text_to_improve": "текст для улучшения",
        "job_description": "описание работы",
        "your_title": "ваша должность",
        "your_summary": "ваше резюме",
        "pain": "боль",
        "agitation": "беспокойство",
        "solution": "решение",
        "post_content": "содержание поста",
        "product_or_service": "продукт или услуга",
        "unique_selling_proposition": "уникальное торговое предложение",
        "audiences_objectives": "цели аудитории",
        "email_to_reply_to": "поле для ответа на электронное письмо",
        "sales_teams_roles": "роли команды продаж"
    },
    "Auth": {
        "email": "Электронная почта",
        "password": "Пароль",
        "firstName": "Имя",
        "lastName": "Фамилия",
        "phoneNumber": "Номер телефона",
        "login_descriptioon": "Посмотрите, что происходит в вашем бизнесе",
        "login_statement": "Войдите в свою учетную запись",
        "email_id": "Электронная почта",
        "Password": "Пароль",
        "Conform_pass": "Подтвердите пароль",
        "RememberMeL": "Запомнить меня",
        "Remember_password": "Запомнить пароль",
        "Forgot_Password": "Забыли пароль",
        "loading": "Загрузка",
        "loging": "Вход",
        "Register": "Зарегистрироваться",
        "NotR": "Еще не зарегистрированы",
        "createAcc": "Создать аккаунт",
        "alredyacc": "Уже есть аккаунт?",
        "ResendEmail": "Отправить письмо повторно",
        "pleasecheck": "Пожалуйста, проверьте вашу электронную почту. Если вы не получили письмо или потеряли его, нажмите ниже, чтобы отправить письмо повторно.",
        "backlogin": "Вернуться к входу",
        "Welcome_Msg": "Добро пожаловать в BRAND_NAME",
        "Welcome_Description": "Получите доступ к эксклюзивным функциям, создав аккаунт",
        "agree": "Я согласен с",
        "tearm": "Условиями использования",
        "and": "и",
        "Privacy_Policy": "Политикой конфиденциальности",
        "forgatepasswordmsg": "Введите электронную почту, связанную с вашим аккаунтом, и мы отправим письмо с инструкциями по сбросу пароля.",
        "ltitle": "Работайте над большими идеями, без рутинных задач.",
        "time_format": "Формат времени",
        "timezone": "Часовой пояс",
        "selectLanguage": "Выберите язык",
        "check_credentials": "Пожалуйста, проверьте свои учетные данные.",
        "check_smtp_credentials": "Пожалуйста, проверьте свои SMTP учетные данные.",
        "smtp_successfully_verified": "Ваш SMTP успешно проверен.",
        "verification_code_invalid": "Ваш код подтверждения неверен.",
        "verification_code_invalid_check_code": "Ваш код подтверждения неверен. Пожалуйста, проверьте код.",
        "verification_mail_sent": "Письмо с подтверждением отправлено успешно. Пожалуйста, проверьте свой почтовый ящик.",
        "no_account_found_for_email": "Аккаунт с указанной электронной почтой не найден.",
        "verify_email_and_try_again": "Подтвердите вашу электронную почту и попробуйте снова.",
        "confirm_password": "Подтвердите пароль",
        "enter_new_password": "Пожалуйста, введите новый пароль",
        "link_expired_resend_email": "Ваша ссылка истекла.",
        "reset_password": "Сбросить пароль",
        "resend_verification_email": "Пожалуйста, нажмите кнопку для повторной отправки письма с подтверждением",
        "link_expired": "Эта ссылка истекла",
        "too_many_request": "Вы отправили слишком много запросов за короткое время. Пожалуйста, подождите и попробуйте снова позже.",
        "previous_wasnot_valid": "Ваш предыдущий пароль был недействителен. Пожалуйста, проверьте и попробуйте снова.",
        "password_wasnot_valid": "Ваш новый пароль был недействителен. Пожалуйста, попробуйте снова.",
        "set_new_password": "Установить новый пароль",
        "verification_link_expired": "Эта ссылка для подтверждения истекла.",
        "verification_link_expired_message": "Пожалуйста, проверьте свой почтовый ящик на наличие последнего письма с подтверждением. Если вы его не получили, попробуйте войти в систему снова, чтобы запросить новое.",
        "oAuthGoogleBtnText": "Продолжить с Гугл"
    },
    "Home": {
        "unlock": "Разблокировать",
        "lock": "Заблокировать",
        "dashboardLockSuccess": "Панель успешно заблокирована",
        "dashboardUnlockSuccess": "Панель успешно разблокирована",
        "Home": "Главная",
        "My_Work": "Моя работа",
        "Done": "Выполнено",
        "To_Do": "К выполнению",
        "no_task_found": "Задачи не найдены",
        "Confirm": "Подтвердить",
        "tourclose": "Вы уверены, что хотите закрыть этот тур? Если вы подтвердите, вы больше не сможете получить доступ к этому гиду.",
        "Queue_List": "Список очереди",
        "AddtoQueue": "Добавить в очередь",
        "noquelist": "Список очереди не найден",
        "Due_Date": "Срок выполнения",
        "createQueueTitle": "Создать очередь",
        "Today": "Сегодня",
        "Calendar": "Календарь",
        "Hide": "Скрыть",
        "Overdue": "Просрочено",
        "Next": "Следующий",
        "Unscheduled": "Не запланировано",
        "task_assign_to_you": "задача назначена вам",
        "Notification_Request": "Запрос уведомления",
        "no": "Нет",
        "yes": "Да",
        "add_task_type": "Добавить тип задачи",
        "are_you_sure": "Вы хотите включить уведомления браузера?"
    },
    "Header": {
        "Project_Forecasting": "Прогноз проекта (Скоро будет доступно)",
        "Resource_Planning": "Планирование ресурсов (Скоро будет доступно)",
        "Projects": "Проекты",
        "Time_Sheet": "Табель учета рабочего времени",
        "User_Timesheet": "Табель учета рабочего времени пользователя",
        "project_Timesheet": "Табель учета рабочего времени проекта",
        "Workload_Timesheet": "Табель учета рабочего времени по нагрузке",
        "Tracker_Timesheet": "Табель учета рабочего времени трекера",
        "Reports": "Отчеты",
        "Milestone_Report": "Отчет по этапам",
        "Time_Forcasting": "Прогноз времени",
        "Chat": "Чат",
        "Notification": "Уведомления",
        "mention": "Упоминание",
        "Tours": "Туры",
        "Logout": "Выйти",
        "Mark_all_as_read": "Отметить все как прочитанное",
        "Mark_all_as_complete": "Отметить все как выполненное",
        "designation": "Должность",
        "upgrade_now": "Обновить сейчас",
        "load_more": "Загрузить больше",
        "take_tour": "Пройти тур",
        "task_details": "Детали задачи",
        "Comments": "Комментарии",
        "activity_log": "Журнал активности",
        "time_log": "Журнал времени",
        "mentions": "Упоминания",
        "Notifications": "Уведомления",
        "no_data_found": "Данные не найдены",
        "search_results": "Результаты поиска",
        "my_profile": "Мой профиль",
        "billing_history": "История платежей",
        "Assignee": "Исполнитель",
        "Due Date": "Срок выполнения",
        "Priority": "Приоритет",
        "Key": "Ключ",
        "Created Date": "Дата создания",
        "Created By": "Создал",
        "advance_search": "Расширенный поиск",
        "for_advance_search": "Для расширенного поиска",
        "get_more": "Получить больше?",
        "to_unlock_activity_view": "Чтобы разблокировать просмотр активности",
        "AssigneeUserId": "Исполнитель",
        "DueDate": "Срок выполнения",
        "TaskKey": "Ключ задачи",
        "Task_Priority": "Приоритет задачи",
        "commentCounts": "Чат",
        "created_by": "Создал",
        "created_date": "Дата создания",
        "create_project": "Создать проект",
        "Company": "Компания"
    },
    "ProjectDetails": {
        "select_project_category": "Выберите категорию проекта",
        "select_currency": "Выберите валюту",
        "description": "Описание",
        "details": "Детали",
        "status": "Статус",
        "assignee": "Исполнитель",
        "key": "Ключ",
        "category": "Категория",
        "source": "Источник",
        "type": "Тип",
        "billing_period": "Период выставления счета",
        "currency": "Валюта",
        "amount": "Сумма",
        "start_date": "Дата начала",
        "end_date": "Дата окончания",
        "no_start_date": "Дата начала не указана",
        "no_end_date": "Дата окончания не указана",
        "no_due_date": "Срок выполнения не указан",
        "msg": "Дата начала не может быть изменена, так как она уже",
        "msgbr": "в пределах диапазона этапа.",
        "startdatemsg0": "Дата начала не может быть изменена, так как она уже",
        "startdatemsg1": "в пределах диапазона этапа.",
        "ok": "Ок",
        "lead": "Ответственный",
        "browse_by_category": "Просмотр по категориям",
        "subtask": "Подзадача",
        "details_project_setup": "Детали настройки проекта",
        "avatar": "Аватар",
        "shared_with": "Поделено с",
        "no_user_selected": "Пользователи не выбраны",
        "required_view": "Необходимые виды",
        "set_the_require": "Установите необходимые виды. Эти виды будут автоматически использоваться при переходе в Проекты, Папки и Списки в BRAND_NAME вместо их ручного создания. После создания виды нельзя удалить.",
        "always_required": "Всегда требуется",
        "make_default": "Сделать по умолчанию",
        "reporter": "Докладчик",
        "copy_task_link": "Копировать ссылку на задачу",
        "copy_task_key": "Копировать ключ задачи",
        "add_que_list": "Добавить в список очереди",
        "remove_que_list": "Удалить из списка очереди",
        "convert_list": "Преобразовать в список",
        "convert_subtask": "Преобразовать в подзадачу",
        "merge": "Объединить",
        "move": "Переместить",
        "convert_task": "Преобразовать в задачу",
        "no_currency_found": "Валюта не найдена",
        "remove_from_queue_list": "Удалить из списка очереди",
        "convert": "Преобразовать",
        "DUPLICATE_AND_OPEN": "Дублировать и открыть",
        "MOVE_AND_OPEN": "Переместить и открыть",
        "CONVERT_AND_OPEN": "Преобразовать и открыть",
        "MERGE_AND_OPEN": "Объединить и открыть"
    },
    "ProjectSlider": {
        "new_project": "Новый проект",
        "no_archived": "Не найдено архивированных данных",
        "you_dont": "У вас нет проектов",
        "archived_list": "Архивированный список",
        "projects": "Проекты",
        "project_name": "Название проекта",
        "folder_name": "Название папки",
        "sprint_name": "Название спринта",
        "show_archive": "Показать архив",
        "hide_archive": "Скрыть архив",
        "try_using_diff": "Попробуйте использовать другие ключевые слова",
        "no_project_found": "Проекты не найдены",
        "no_result_found": "Результатов не найдено",
        "select_project_status": "Выберите статус проекта",
        "no_activity_log_found": "Журнал активности не найден"
    },
    "Projects": {
        "sprint": "Спринт",
        "folder": "Папка",
        "task_view": "Просмотр задачи",
        "default_view": "Представление по умолчанию",
        "add_view": "Добавить представление",
        "rename": "Переименовать",
        "pin": "Закрепить",
        "edit_code": "Редактировать код",
        "copy_link": "Копировать ссылку",
        "delete": "Удалить",
        "view": "Просмотр",
        "watchers": "Наблюдатели",
        "files_links": "Файлы и ссылки",
        "audio_files": "Аудиофайлы",
        "project_permissions": "Права доступа к проекту",
        "color_avatar": "Цвет и аватар",
        "duplicate": "Дублировать",
        "close_project": "Закрыть проект",
        "archive": "Архивировать",
        "search_in": "Поиск в",
        "expanded": "Развернутый",
        "collapsed": "Свернутый",
        "me": "Я",
        "status": "Статус",
        "priority": "Приоритет",
        "due_date": "Срок выполнения",
        "group_by": "Группировать по",
        "subtask": "Подзадача",
        "task_name": "Название задачи",
        "task_key": "Ключ задачи",
        "everyone": "Все",
        "private": "Частный",
        "share_with": "Поделиться с",
        "create_new_list": "Создать новый спринт",
        "create_new_folder": "Создать новую папку",
        "restore": "Восстановить",
        "unpin": "Открепить представление",
        "pinview": "Закрепить представление",
        "deleteview": "Удалить представление",
        "close": "Закрыть",
        "cancel": "Отмена",
        "tasks": "Задачи",
        "save": "Сохранить",
        "create_project": "Создать проект",
        "use_template": "Использовать шаблон",
        "blank_project": "Пустой проект",
        "no_category_found": "Категория не найдена",
        "template": "Шаблон",
        "save_create": "Сохранить и создать",
        "save_tamplete": "Сохранить как шаблон",
        "previous": "Предыдущий",
        "new_task": "Новая задача",
        "add_subtask": "Добавить подзадачу",
        "list_of_user": "Список пользователей",
        "list_of_project_status": "Список статусов проектов",
        "list_of_task_type": "Список типов задач",
        "list_of_task_status": "Список статусов задач",
        "list_cc": "Список cc",
        "category_list": "Список категорий",
        "created_by": "Создано",
        "tags": "Теги",
        "task_type": "Тип задачи",
        "workspace": "Рабочее пространство",
        "project_color": "Цвет проекта",
        "search": "Поиск",
        "add_task_need": "Добавьте тип задач, который вам нужен",
        "what_task_want": "Какой тип задачи вы хотите",
        "no_sub_tasks_found": "Подзадачи не найдены",
        "all_project": "Все проекты",
        "closed_project": "Закрытые проекты",
        "go_to_project": "Перейти к проектам",
        "reopen_project": "Переоткрыть проект",
        "required_view": "Необходимые представления",
        "project_status": "Добавьте статусы для проекта",
        "what_project": "Какой статус проекта вы хотите",
        "active_status": "Активный статус",
        "done_status": "Статус выполнено",
        "add_status": "Добавить статус",
        "close_status": "Закрыть статус",
        "submit": "Отправить",
        "Audio_Files": "Аудиофайлы",
        "Files_&_Links": "Файлы и ссылки",
        "no_audio_file": "Аудиофайлы не найдены",
        "change_color": "Изменить цвет и аватар",
        "files": "Файлы",
        "links": "Ссылки",
        "about": "О проекте",
        "result": "результаты",
        "seconds": "секунды",
        "sort_by": "Сортировать по",
        "relevance": "Релевантность",
        "last_update": "Последнее обновление",
        "last_created": "Последнее создание",
        "issue": "Проблема",
        "update": "Обновить",
        "date": "Дата",
        "time": "Время",
        "duration": "Продолжительность",
        "duplicate_task": "Дублировать задачу",
        "projects": "Проекты",
        "browse_projects": "Просмотр проектов",
        "location": "Местоположение",
        "add_new": "Добавить новый",
        "create_compnay": "Создать компанию",
        "company_name": "Название компании",
        "archived_project": "Архивированный проект",
        "assignee_teams": "Команды",
        "assignee_user": "Пользователи",
        "all": "Все",
        "restore_project": "Восстановить проект",
        "delete_project": "Удалить проект",
        "items_per_page": "Элементов на странице",
        "Assignee": "Исполнитель",
        "Project_Created_Date": "Дата создания проекта",
        "Project_Status": "Статус проекта",
        "Project_Type": "Тип проекта",
        "Comments_Counts": "Количество комментариев",
        "Created_Date": "Дата создания",
        "Name": "Имя",
        "Running_Time_Tracker": "Рабочий таймер",
        "Assigned_to": "Назначено на",
        "Project": "Проект",
        "Currency": "Валюта",
        "Milestone_Type": "Тип этапа",
        "Project_Category": "Категория проекта",
        "Comment_Type": "Тип комментария",
        "results_in_time": "Результаты через",
        "create_blank_project": "Создать пустой проект",
        "create_project_using_template": "Создать проект с использованием шаблона",
        "choose_apps": "Выберите приложения"
    },
    "Watcher": {
        "ignore": "Игнорировать",
        "participating_mentions": "Участие и упоминания {'@'}",
        "list_of_watcher": "Список наблюдателей",
        "all_activity": "Вся активность",
        "watchers_list": "Список наблюдателей",
        "owner": "Владелец"
    },
    "ViewList": {
        "List": "Список",
        "Board": "Доска",
        "Project Details": "Детали проекта",
        "Comments": "Комментарии",
        "Calendar": "Календарь",
        "Activity": "Активность",
        "Workload": "Рабочая нагрузка",
        "Gantt": "Гантт",
        "Table": "Таблица",
        "Timeline": "Хронология",
        "Embed": "Встроить",
        "Comment": "Комментарий",
        "to_unlock_list_view": "Чтобы разблокировать представление списка",
        "error_message_for_empty": "Пожалуйста, выберите хотя бы один вид",
        "set_as_default": "Установить по умолчанию",
        "remove_as_default": "Удалить из умолчаний"
    },
    "Apps": {
        "tags": "Теги",
        "Priority": "Приоритет",
        "TimeEstimates": "Оценка времени",
        "Milestones": "Этапы",
        "MultipleAssignees": "Несколько исполнителей",
        "CustomFields": "Пользовательские поля",
        "TimeTracking": "Отслеживание времени",
        "AI": "Искусственный интеллект"
    },
    "Tags": {
        "no_tags_found": "Теги не найдены",
        "search_or_create_new": "Поиск или создание нового",
        "change_color": "Изменить цвет",
        "delete_tag": "Удалить тег",
        "delete_tag_desc": "Вы уверены, что хотите удалить тег везде в этом пространстве?",
        "note_msg": "Нажмите Enter, чтобы создать новый тег",
        "This_tag_has_already_been_added": "Этот тег уже добавлен",
        "Tag_name_required": "Требуется имя тега"
    },
    "Embeded": {
        "Anything": "Что угодно",
        "Sheets": "Google Sheets",
        "Docs": "Google Docs",
        "Youtube": "Youtube",
        "Figma": "Figma",
        "The_name_is_required": "Необходимо указать имя",
        "The_name_should_be_at_least_3_characters_long": "Имя должно содержать не менее 3 символов",
        "The_url_is_required": "Необходим URL",
        "Please_enter_valid_url": "Пожалуйста, введите правильный URL",
        "URL_already_exists": "URL уже существует",
        "The_Html_code_is_required": "Необходим HTML код",
        "name_already_exists": "Это имя уже существует",
        "to_unlock_embed_view": "Чтобы разблокировать представление Embed"
    },
    "ViewListdescription": {
        "list_view": "Используйте представление списка для организации задач любым возможным способом – сортировка, фильтрация, группировка и настройка колонок.",
        "kanban_view": "Создайте свою идеальную доску и легко перетаскивайте задачи между колонками.",
        "projectdetail_view": "Добавьте начальные требования, контрольные списки и вложения, чтобы ваша команда могла детально понять проект.",
        "Comments_view": "Добавляйте комментарии в реальном времени о чем угодно, чтобы ваша команда получала уведомления и могла ответить.",
        "calender_view": "Календарь — это ваше место для планирования, составления расписания и управления ресурсами.",
        "table_view": "Легко управляйте, обновляйте и организовывайте свои задачи с помощью представления таблицы.",
        "workload_view": "Посмотрите на возможности своей команды, кто перегружен или не доработал, и перераспределите задачи соответственно.",
        "activitylog_view": "Получите агрегированное представление всех активностей по локации. Фильтруйте по людям и типам активности для детализированного отображения.",
        "add_msg1": "Добавьте приложения и сайты рядом с вашими задачами с помощью представления Embed",
        "add_msg2": "чтобы сэкономить время и уменьшить количество переключений контекста.",
        "view_name": "Название представления",
        "embed_URL": "Встроенный URL",
        "embed_HTML": "Встроенный HTML",
        "private_view": "Приватное представление"
    },
    "Filters": {
        "filter": "Фильтры",
        "learnmorefilter": "Узнайте больше о фильтрах",
        "pleaseselectvalid": "Пожалуйста, выберите все допустимые опции",
        "confirm": "Подтвердить",
        "are_you_sure": "Вы уверены, что хотите удалить?",
        "clearall": "Очистить все",
        "addfilter": "Добавить фильтр",
        "where": "Где",
        "filtering_field": "Поле фильтрации",
        "no_date_found": "Дата не найдена",
        "save_this_filters": "Сохранить эти фильтры",
        "save_filter": "Сохранить фильтр",
        "save": "Сохранить",
        "update_filter": "Обновить фильтр",
        "my_filter": "Мой фильтр",
        "no_data_found": "Данные не найдены",
        "show_result": "Показать результат",
        "save_filters": "Сохранить фильтры",
        "filter_by": "Фильтровать по",
        "projects": "Проекты",
        "teams": "Команды",
        "user": "Пользователь",
        "no_comment_found": "Комментариев не найдено",
        "no_project_found": "Проект не найден",
        "no_file_found": "Файлы не найдены",
        "no_link_found": "Ссылки не найдены",
        "filter_operator": "Оператор фильтра",
        "options": "Опции",
        "priorities": "Приоритеты",
        "select_all": "Выбрать все",
        "milestone_type": "Тип этапа",
        "comment_type": "Тип комментария",
        "a_to_z": "От A до Z",
        "no_files_found": "Файлы не найдены",
        "no_links_found": "Ссылки не найдены",
        "no_links_or_files_found": "Ссылки или файлы не найдены",
        "z_to_a": "От Z до A",
        "sort_by": "Сортировать по",
        "A-Z": "A-Z",
        "Ascending": "По возрастанию",
        "Descending": "По убыванию",
        "No": "Нет",
        "Yes": "Да",
        "Z-A": "Z-A",
        "Save_this_Filter": "Сохранить этот фильтр",
        "Enter_Filter_Name": "Введите название фильтра",
        "Select_Options": "Выберите опции",
        "Equal_To": "Равно",
        "Greater_Than": "Больше чем",
        "Is": "Это",
        "Less_Than": "Меньше чем",
        "Clear_All": "Очистить все",
        "select_assignee": "Выберите исполнителя",
        "select_project_types": "Выберите типы проектов",
        "unselect_all": "Отменить выбор всех",
        "are_you_suredelete": "Вы уверены, что хотите удалить?",
        "Not_Equals_To": "Не является"
    },
    "conformationmsg": {
        "archive": "Список можно архивировать, чтобы скрыть его, но он может быть восстановлен в любой момент. Все задачи сохраняются и остаются доступными для поиска после архивации списка.",
        "delete": "Задачи и шаблоны этого проекта будут удалены. Введите название проекта, чтобы подтвердить, что вы действительно хотите удалить все задачи, шаблоны и этот проект.",
        "archive0mesg": "Введите название проекта, чтобы подтвердить, что вы действительно хотите закрыть этот проект",
        "sprintclosemsg": "Введите название спринта, чтобы подтвердить, что вы действительно хотите закрыть этот спринт",
        "type": "Тип",
        "are_you_sure": "Вы уверены?",
        "no_revert_msg": "Вы не сможете отменить это!",
        "yes_delete": "Да, удалить!",
        "task_will_become_subtasks_of": "задача станет подзадачей",
        "Are_you_sure_you_want_to_delete": "Вы уверены, что хотите удалить?",
        "subtasks_will_become_subtasks_of": "Подзадачи станут подзадачами",
        "unlock_board_view": "Чтобы разблокировать представление доски",
        "unlock_project_detail_view": "Чтобы разблокировать представление деталей проекта",
        "unlock_table_view": "Чтобы разблокировать представление таблицы",
        "unlock_workload_view": "Чтобы разблокировать представление рабочей нагрузки",
        "to_unlock_tracker_timesheet": "Чтобы разблокировать трекер рабочего времени",
        "to_unlock_user_timesheet": "Чтобы разблокировать рабочий лист пользователя",
        "unlock_calendar_view": "Чтобы разблокировать представление календаря"
    },
    "Description": {
        "description": "Описание",
        "edit": "Редактировать",
        "add_description": "Добавить описание",
        "show_more": "Показать больше",
        "show_less": "Показать меньше",
        "description_placeholder": "Напишите что-нибудь или введите '/' для команд и действий AI",
        "saved": "Сохранено"
    },
    "Checklist": {
        "checklist": "Контрольный список",
        "add_checklist": "Добавить контрольный список",
        "suggest_checklists": "Предложить контрольные списки",
        "Checklists": "Контрольные списки",
        "to_unlock_checklist": "Чтобы разблокировать контрольный список"
    },
    "Attachments": {
        "attachments": "Прикрепления",
        "drag_file": "Здесь вы также можете перетащить файлы.",
        "see_all": "Посмотреть все",
        "drop_file": "Перетащите файлы сюда для прикрепления или",
        "browse": "Обзор",
        "no_preview_found": "Предварительный просмотр не найден",
        "show_all_pages": "Показать все страницы",
        "drop_here": "Перетащите сюда"
    },
    "Milestone": {
        "milestone": "Этап",
        "milestone_name": "Название этапа",
        "status_date": "Дата статуса",
        "total_amount": "Общая сумма",
        "are_you_sure": "Вы уверены, что хотите удалить этап?",
        "add_new": "Добавить новый",
        "mileston_status": "Статус этапа",
        "project_name": "Название проекта",
        "end_date": "Дата завершения",
        "start_date": "Дата начала",
        "estimated_release": "Ожидаемый выпуск",
        "release_request_sent": "Запрос на выпуск отправлен",
        "released": "Выпущен",
        "not_funded": "Не профинансирован",
        "funded": "Профинансирован",
        "project_milestone_Status": "Статус этапа проекта",
        "milestone_status_name": "Название статуса этапа",
        "date_displaye": "Дата отображения в календаре",
        "past": "Прошлое",
        "feature": "Будущее",
        "milestone_weekly_range": "Еженедельный диапазон этапа",
        "file_extensions": "Расширения файлов",
        "avatar": "Аватар",
        "adding_estimated": "Добавить предполагаемое количество часов",
        "range": "Диапазон",
        "user": "Пользователь",
        "refunded_amount": "Возвращенная сумма",
        "Max_2_decimal_places_allowed": "Максимум 2 знака после запятой",
        "The_refunded_amount_field_should_not_be_more_then_amount": "Поле возврата не должно превышать сумму",
        "Amount_field_should_not_be_smaller_than_the_refunded_amount": "Поле суммы не должно быть меньше возвращаемой суммы",
        "The_minute_field_must_be_59_or_less": "Поле минут должно быть 59 или меньше",
        "The_hours_field_is_required": "Поле часов обязательно",
        "Name_already_exists": "Имя уже существует",
        "The_milestone_status_field_is_required": "Поле статуса этапа обязательно",
        "The_milestone_status_field_must_be_at_leat_characters": "Поле статуса этапа должно содержать хотя бы 3 символа",
        "actual_amount": "Фактическая сумма",
        "partially_refunded": "Частично возвращено",
        "refunded_amount_should_not_exceed_amount": "Возвращаемая сумма не должна превышать сумму",
        "total_partially_refunded": "Общая частичная возвратная сумма",
        "field_should_not_be_smaller_than_refund_amount": "Поле не должно быть меньше суммы возврата",
        "white_color_not_allowed": "Белый цвет не разрешен. Пожалуйста, выберите правильный цвет",
        "billing": "Выставление счетов",
        "per_hour": "За час",
        "adding_taskPlanning": "Добавить планирование задач"
    },
    "Comment": {
        "created_by": "Создано",
        "created_on": "Создано на",
        "task_name": "Название задачи"
    },
    "UserTimesheet": {
        "back_projects": "Назад к проектам",
        "user_timesheet": "Временная ведомость пользователя",
        "back": "Назад",
        "tracked_time": "Отслеживаемое время",
        "manual_time": "Ручное время",
        "users": "Пользователи",
        "logged": "Зарегистрировано",
        "hours": "Часы",
        "estimated": "Ожидаемое",
        "no_records_found": "Записи не найдены",
        "project_timesheet": "Временная ведомость проекта",
        "tracker_timesheet": "Временная ведомость трекера",
        "workload_timesheet": "Временная ведомость рабочей нагрузки",
        "milestone_reports": "Отчеты по этапам",
        "add_time": "Добавить время",
        "add_time_log": "Добавить запись о времени",
        "edit_time_log": "Редактировать запись о времени",
        "Teams": "Команды",
        "Users": "Пользователи",
        "Projects": "Проекты",
        "task_planning": "Планирование задач",
        "task_remaining_planning": "Оставшиеся часы",
        "planned": "Запланировано"
    },
    "ProjectWorkplace": {
        "msg1": "Проект может быть совместно использован с участниками. Вы можете добавлять гостей в папки, списки и задачи после создания проекта.",
        "msg2": "В настоящее время нет планов по созданию частных или публичных проектов. Чтобы начать проект, необходимо обновить план."
    },
    "CustomField": {
        "custom_field": "Пользовательское поле",
        "create_custom_field": "Создать пользовательское поле",
        "lable": "Метка",
        "action": "Действие",
        "add_custom_field": "Добавить пользовательское поле",
        "add_new_custom_field": "Добавить новое пользовательское поле",
        "field_name": "Имя поля",
        "date_created": "Дата создания",
        "add_another_item": "Добавить еще один элемент",
        "choose_ready_made_list": "Выберите готовый список вариантов (например, дни, месяцы и т. д.)",
        "predefined_options": "Предустановленные варианты",
        "selected_by_default": "Выбрано по умолчанию",
        "allow_time_with_date": "Разрешить пользователям указывать время с датой.",
        "date_format": "Формат даты",
        "days_of_week": "Дни недели",
        "past_and_future": "Прошлое и будущее",
        "select_date_format": "Выберите формат даты. D - день, M - месяц, Y - год.",
        "select_dates_past_future": "Разрешить пользователям выбирать даты в прошлом или будущем",
        "select_time_format": "Выберите формат времени",
        "time_format": "Формат времени",
        "unchecking_day_calendar": "Снятие флажка с дня сделает его недоступным в календаре",
        "future": "Будущее",
        "past": "Прошлое",
        "enter_maximum_limit": "Введите максимальный лимит",
        "enter_minimum_limit": "Введите минимальный лимит",
        "limit_minimum_or_maximum_value": "Ограничьте минимальное или максимальное значение, которое может быть введено для этого поля",
        "maximum_limit_type_not_allowed_value": "Введенное значение для максимального лимита является недопустимым.",
        "maximum_value_should_be_greater_than_minimum_value": "Максимальное значение должно быть больше минимального",
        "minimum_limit_type_not_allowed_value": "Введенное значение для минимального лимита является недопустимым.",
        "minimum_value_should_not_be_greater_than_maximum_value": "Минимальное значение не должно быть больше максимального",
        "no_country_found": "Страна не найдена",
        "enter_maximum_limit_type": "Введите тип максимального лимита",
        "enter_minimum_limit_type": "Введите тип минимального лимита",
        "limit_minimum_or_maximum_text_allowed": "Ограничьте минимальное или максимальное количество текста, которое может быть введено в этом поле",
        "max_should_be_greater_than_min": "Макс. значение должно быть больше мин.",
        "min_should_be_less_than_max": "Мин. значение должно быть меньше макс.",
        "separator": "Разделитель",
        "countryCode": "Включите эту настройку, чтобы изменить код страны."
    },
    "Category": {
        "cateory_name": "Название категории",
        "create_category": "Создать категорию",
        "create_channel": "Создать канал",
        "no_chat_found": "Чатов не найдено",
        "upgradeplanemsg": "Чтобы получить доступ к этой функции, пожалуйста, обновите ваш план."
    },
    "Channel": {
        "create_channel": "Создать канал",
        "msg1": "Вы достигли максимального лимита создания публичных и частных каналов. Чтобы использовать эту функцию, пожалуйста, обновите ваш план",
        "channel_name": "Название канала",
        "icons": "Иконки",
        "or": "или",
        "only_share_with": "Делитесь только с",
        "private_channel": "Частный канал",
        "msg2": "Только выбранные члены и роли смогут просматривать этот канал",
        "allowmsg2": "Разрешить участникам отправлять сообщения в этом канале",
        "send_messages": "Отправить сообщения",
        "choose_to_upload": "Выберите изображение для загрузки",
        "private_channel_limit_reached": "Вы достигли лимита для создания частных каналов. Вы можете создавать только публичные каналы. Если вы хотите создать частный канал, пожалуйста, обновите ваш план.",
        "public_channel_limit_reached": "Вы достигли лимита для создания публичных каналов. Вы можете создавать только частные каналы. Если вы хотите создать публичный канал, пожалуйста, обновите ваш план."
    },
    "Templates": {
        "delete_template": "Удалить шаблон",
        "project_status": "Статус проекта",
        "task_status": "Статус задачи",
        "no_app_selected": "Приложения не выбраны",
        "default_views": "Настройка по умолчанию для представлений",
        "apps": "Программы",
        "add_new_templete": "Добавить новый шаблон",
        "templates": "Шаблоны",
        "s": "s",
        "template_name": "Название шаблона",
        "upload_image": "Загрузить изображение",
        "all_good": "Все в порядке",
        "create_template": "Создать шаблон",
        "new_template": "Новый шаблон",
        "remove": "Удалить",
        "enable_apps": "Включить приложения",
        "Turn": "Включить",
        "all_apps": "все приложения",
        "off": "выкл.",
        "on": "вкл.",
        "upload": "Загрузить",
        "save_template": "Сохранить шаблон",
        "setup_status": "Настройка статусов для задач",
        "what_task": "Какой статус задачи вам нужен?",
        "select_task_status": "Выберите статус задачи",
        "delete_template_confirmation": "Вы уверены, что хотите удалить шаблон?",
        "ai_sidebar_title": "Создать шаблон с помощью ИИ",
        "ai_label_category": "Категория",
        "ai_label_description": "Описание",
        "ai_button_text_requested_changes": "Запросить изменения",
        "ai_min_view_msg_text": "Требуется хотя бы один просмотр",
        "ai_min_msg_text": "Минимум 10 символов",
        "ai_before_desc_placeholder": "Введите описание кейса для генерации шаблона",
        "ai_after_desc_placeholder": "Здесь вы можете продолжать задавать вопросы для соответствующих изменений",
        "try_with_ai": "Попробуйте с ИИ",
        "msg_search_result_found": "Вот некоторые предложенные шаблоны, соответствующие вашим требованиям. Вы можете выбрать любой или просто нажмите, чтобы создать с помощью ИИ",
        "msg_search_result_not_found": "Подходящие шаблоны не найдены. Чтобы создать свой с помощью ИИ, просто нажмите"
    },
    "Settings": {
        "add_new_projects": "Добавить новый проект",
        "task_priority": "Приоритет задачи",
        "maximum_image_size": "Максимальный размер изображения",
        "warning": "Предупреждение",
        "cant_delete": "нельзя удалить",
        "priority_in_use": "Пользователь не может удалить приоритет PRIORITY_NAME, так как он уже используется.",
        "company_name": "Название компании",
        "phone": "Телефон",
        "country": "Страна",
        "state": "Штат",
        "city": "Город",
        "select_date_format": "Выберите формат даты",
        "save_changes": "Сохранить изменения",
        "currencies": "Валюты",
        "add_remove_cur": "Добавить/удалить валюты",
        "change_image": "Изменить изображение",
        "Priorities_already_Exists": "Приоритеты уже существуют",
        "The_priority_image_field_is_required": "Поле изображения приоритета обязательно",
        "The_priority_name_field_is_required": "Поле названия приоритета обязательно",
        "The_priority_name_field_must_be_at_least": "Поле названия приоритета должно содержать хотя бы 3 символа",
        "The file extension field is required": "Поле расширения файла обязательно",
        "The_file_extension_field_must_be_at_least": "Поле расширения файла должно содержать хотя бы 3 символа",
        "file_extension_is_not_supported": "Расширение файла не поддерживается",
        "file_extension_already_Exists": "Расширение файла уже существует",
        "The_file_extension_field_is_required": "Поле расширения файла обязательно"
    },
    "Members": {
        "invite": "Пригласить",
        "all_members": "Все члены",
        "removed_members": "Удаленные члены",
        "name": "Имя",
        "role": "Роль",
        "last_active": "Последняя активность",
        "time_tracker": "Трекер времени",
        "settings": "Настройки",
        "removeuser": "Удалить пользователя",
        "adduser": "Добавить пользователя",
        "invite_user": "Пригласить пользователя",
        "remove_request": "Запрос на удаление",
        "resend_invitation": "Повторно отправить приглашение",
        "cancel_invitation": "Отменить приглашение",
        "Invitation_mail_sent_sucessfully": "Пригласительное письмо успешно отправлено",
        "confirm_change_user_designation": "Вы уверены, что хотите изменить должность этого пользователя на",
        "confirm_change_user_role": "Вы уверены, что хотите изменить роль этого пользователя на",
        "Import_users_from_csv": "Импортировать пользователей из CSV"
    },
    "Upgrades": {
        "take_next_step": "Сделайте следующий шаг с вашей работой",
        "you_are_on": "Вы сейчас на",
        "per_year": "В год",
        "per_month": "В месяц",
        "current_plane": "Текущий план",
        "per_member": "За участника",
        "and_much_more": "и многое другое",
        "upgrade_to": "Перейти на",
        "select_payment_method": "Выберите способ оплаты",
        "plan": "План",
        "plane_upgrade": "Обновление плана успешно",
        "plane_upgrade_msg": "Обновление плана успешно! Ваша подписка была обновлена. Пожалуйста, подождите 2-3 минуты, чтобы изменения вступили в силу и вы могли полностью насладиться расширенными функциями и улучшениями!",
        "something_wrong": "Что-то пошло не так. Пожалуйста, попробуйте снова",
        "unsucessfull_msg": "Неудачное обновление плана. Мы столкнулись с проблемой при обновлении вашего плана. Пожалуйста, попробуйте снова или свяжитесь с поддержкой для помощи.",
        "upgrade_your_plan": "Обновите ваш план",
        "to_unlock_custom_field": "Чтобы разблокировать пользовательское поле",
        "unlimited": "Неограниченно",
        "the_feature_not_available": "Эта функция недоступна в вашем текущем плане",
        "unlock_project_permission": "Чтобы разблокировать разрешения для проекта",
        "unlock_custom_field": "Чтобы разблокировать пользовательское поле",
        "to_unlock_milestone": "Чтобы разблокировать этап",
        "to_unlock_milestone_report": "Чтобы разблокировать отчет по этапу",
        "to_unlock_security": "Чтобы разблокировать безопасность и разрешения",
        "to_unlock_team": "Разблокировать команду",
        "to_unlcok_project": "Чтобы разблокировать проект",
        "You_have_reached_the_free_plan_limit": "Вы достигли лимита PLAN_NAME",
        "require_upgrade_message": "Вы можете создать до PROJECT_COUNT проектов в плане PROJECT_NAME. Создайте больше досок, обновив свой план.",
        "are_you_sure_you_want_to_update": "Вы уверены, что хотите обновить?",
        "find_out_whats_included_in_this_update": "Узнайте, что включено в это обновление",
        "improved_performance": "Улучшенная производительность",
        "install_now": "Установить сейчас",
        "later": "Позже",
        "please_see_below_for_a_list_of_changes_to_the_features": "Пожалуйста, посмотрите ниже список изменений в функциях.",
        "to_integrate_new_services_into_an_alian_hub": "Чтобы интегрировать новые сервисы в Hyphen OI Pro.",
        "whats_new": "Что нового?",
        "check_to_agree_with_above_points": "Отметьте, чтобы согласиться с вышеуказанными пунктами",
        "general_notes": "Общие заметки",
        "update_now": "Обновить сейчас",
        "unlock_channel": "Чтобы разблокировать канал",
        "unlock_chat": "Чтобы разблокировать чат",
        "unlock_one_chat": "Чтобы разблокировать чат один на один",
        "public_private_creation_time_limit_reached": "Вы достигли лимита на создание проектов. Если вы хотите создать проект, пожалуйста, обновите свой план.",
        "public_creation_time_limit_reached": "Вы достигли лимита на создание публичных проектов. Вы можете создавать только частные проекты. Если вы хотите создать публичный проект, пожалуйста, обновите свой план.",
        "private_creation_time_limit_reached": "Вы достигли лимита на создание частных проектов. Вы можете создавать только публичные проекты. Если вы хотите создать частный проект, пожалуйста, обновите свой план."
    },
    "Permissions": {
        "advanced_permission": "Расширенные разрешения",
        "allow_admins": "Разрешить администраторам управлять частными пространствами",
        "when_admin_enable": "Когда включено, администраторы смогут добавлять/удалять людей и передавать права собственности на все пространства.",
        "show_all_projects": "Показать все проекты",
        "when_user_enable": "Когда включено, пользователи смогут видеть все глобальные проекты.",
        "show_all_task": "Показать все задачи",
        "when_user_enable_sprint": "Когда включено, пользователи смогут видеть все задачи в спринтах.",
        "own": "Собственный",
        "select": "Выбрать",
        "Member": "Член",
        "Guest": "Гость",
        "None": "Нет",
        "Read": "Чтение",
        "add_new_team": "Добавить новую команду",
        "Read & Write": "Чтение и запись",
        "Support": "Поддержка",
        "select_priorities": "Выбрать приоритеты",
        "apply_permission": "Применить разрешения",
        "project_permission_description": "Чтобы переопределить глобальные разрешения, они отключены по умолчанию. После включения вы сможете управлять разрешениями для проектов и задач. Если они отключены, будут применяться глобальные разрешения",
        "project_permission_title_disable": "Возможность предоставлять пользовательские разрешения для этого проекта будет отключена",
        "project_permission_title_enable": "Возможность предоставлять пользовательские разрешения для этого проекта будет включена",
        "reset_permission": "Сбросить разрешения"
    },
    "subProjectRulesNames": {
        "Project_List": "Список проектов",
        "Project_Create": "Создание проекта",
        "Project_Name_Edit": "Редактирование названия проекта",
        "Project_Sprint_Create": "Создание спринта проекта",
        "Project_folder_Create": "Создание папки проекта",
        "Project_folder_Name_Edit": "Редактирование названия папки проекта",
        "Project_sprint_Name_Edit": "Редактирование названия спринта проекта",
        "Project_Details": "Детали проекта",
        "Project_Status_Change": "Изменение статуса проекта",
        "Project_Assignee": "Назначение проекта",
        "Project_Category": "Категория проекта",
        "Proejct_Source": "Источник проекта",
        "Project_Type": "Тип проекта",
        "Project_Currency": "Валюта проекта",
        "Project_Amount": "Сумма проекта",
        "Project_Start Date": "Дата начала проекта",
        "Project_End Date": "Дата окончания проекта",
        "Project_Due Date": "Срок выполнения проекта",
        "Project_Close": "Закрытие проекта",
        "Project_Description": "Описание проекта",
        "Project_Checklist": "Чек-лист проекта",
        "Project_Checklist_Assign/remove": "Назначение/удаление чек-листа проекта",
        "Project_Attachments": "Прикрепления проекта",
        "Project_Milestone": "Этап проекта",
        "Task_list": "Список задач",
        "Task_Create": "Создание задачи",
        "Sub_Task_Create": "Создание подзадачи",
        "Task_Name_Edit": "Редактирование названия задачи",
        "Task_Status": "Статус задачи",
        "Task_Assignee": "Назначение задачи",
        "Task_Priority": "Приоритет задачи",
        "Task_Due_Date": "Срок задачи",
        "Task_Estimated_Hours": "Оценочные часы задачи",
        "Task_Description": "Описание задачи",
        "Task_Checklist": "Чек-лист задачи",
        "Task_Checklist_Assign/remove": "Назначение/удаление чек-листа задачи",
        "Task_Attachments": "Прикрепления задачи",
        "Show_Tasks": "Показать задачи",
        "Custom_Field": "Пользовательское поле",
        "Edit_Company": "Редактирование компании",
        "File_Extensions": "Расширения файлов",
        "Project_Milestone_Status": "Статус этапа проекта",
        "Invite_Member": "Пригласить участника",
        "Member_list": "Список участников",
        "Create_Team": "Создать команду",
        "Team_List": "Список команд",
        "Security_&_Permissions": "Безопасность и разрешения",
        "Role_Management": "Управление ролями",
        "Designation": "Должность",
        "Milestone_Weekly_Range": "Еженедельный диапазон этапа",
        "User_Timesheet": "Временная ведомость пользователя",
        "Project_Timesheet": "Временная ведомость проекта",
        "Workload__Timesheet": "Временная ведомость рабочей нагрузки",
        "Milestone_Report": "Отчет по этапам",
        "Project": "Проект",
        "Task": "Задача",
        "Company_Settings": "Настройки компании",
        "Sheet_Settings": "Настройки листа",
        "Team_Color": "Цвет команды",
        "Team_Name": "Имя команды",
        "Add_Member": "Добавить участника",
        "Add_New_Designation": "Добавить новую должность"
    },
    "Notification": {
        "Notification": "Уведомление",
        "notification_setting": "Настройки уведомлений",
        "browser": "Браузер",
        "mobile": "Мобильный",
        "before": "До",
        "chat": "Чат",
        "project": "Проект",
        "tasks": "Задачи",
        "before_project_due_date": "Срок выполнения проекта",
        "before_project_end_date": "Дата окончания проекта",
        "before_task_due_date": "Срок задачи",
        "before_task_end_date": "Дата окончания задачи",
        "message_create": "Создание сообщения",
        "project_create": "Создание проекта",
        "project_name": "Название проекта",
        "project_status_change": "Изменение статуса проекта",
        "project_assignee": "Назначение проекта",
        "project_lead": "Руководитель проекта",
        "project_category": "Категория проекта",
        "project_source": "Источник проекта",
        "project_type": "Тип проекта",
        "project_currency": "Валюта проекта",
        "project_amount": "Сумма проекта",
        "project_start_date": "Дата начала проекта",
        "project_end_date": "Дата окончания проекта",
        "project_due_date": "Срок проекта",
        "project_close": "Закрытие проекта",
        "project_description": "Описание проекта",
        "project_checklist": "Чек-лист проекта",
        "project_checklist_assign": "Назначить чек-лист проекта",
        "project_checklist_remove": "Удалить чек-лист проекта",
        "project_attachments": "Прикрепления проекта",
        "project_milestone": "Этап проекта",
        "project_milestone_status_change": "Изменение статуса этапа проекта",
        "project_sprint_create": "Создание спринта проекта",
        "project_folder_create": "Создание папки проекта",
        "comments_im_@mentioned_in": "Комментарии, в которых меня {'@'}упомянули",
        "task_notification": "Уведомление о задаче",
        "task_create": "Создание задачи",
        "task_edit": "Редактирование задачи",
        "task_status": "Статус задачи",
        "task_assignee": "Назначение задачи",
        "task_priority": "Приоритет задачи",
        "task_type": "Тип задачи",
        "task_due_date": "Срок выполнения задачи",
        "task_description": "Описание задачи",
        "task_checklist": "Чек-лист задачи",
        "task_checklist_assign": "Назначить чек-лист задачи",
        "task_checklist_remove": "Удалить чек-лист задачи",
        "task_attachments": "Прикрепления задачи",
        "comments_Im_@mentioned_in": "Комментарии, в которых меня {'@'}упомянули",
        "logged_hours_notification": "Уведомление о часах",
        "after_3_hours_today_pending_hours": "Уведомление о незавершенных часах через 3 часа сегодня",
        "task_estimated_hours": "Оценочные часы задачи"
    },
    "TimeTracker": {
        "TimeTracker": "Трекер времени",
        "unlock": "Разблокируйте вселенную с трекером Hyphen OI Pro на вашем рабочем столе!",
        "smooth": "Плавно отслеживайте время, затраченное пользователями на проекты или задачи с помощью отслеживания времени.",
        "click": "клик",
        "No_Record_Found": "Записи не найдены",
        "total": "Итого",
        "screenshot_preview": "Предпросмотр скриншота",
        "log_time_found_no_screenshot": "Время зарегистрировано, но скриншот не был захвачен для этого периода."
    },
    "settingslider": {
        "Time Tracking": "Отслеживание времени",
        "Notifications": "Уведомления",
        "Company": "Компания",
        "My Settings": "Мои настройки",
        "Security & Permissions": "Безопасность и разрешения",
        "Upgrade": "Обновление",
        "Custom Field Manager": "Менеджер пользовательских полей",
        "Templates": "Шаблоны",
        "Projects": "Проекты",
        "Teams": "Команды",
        "Members": "Участники",
        "Settings": "Настройки",
        "Change Password": "Изменить пароль"
    },
    "Chat": {
        "welcome_message": "Добро пожаловать в BRAND_NAME",
        "msg2": "Это совершенно новая группа. Вот несколько шагов, которые помогут вам начать. Для получения дополнительной информации ознакомьтесь с нашим руководством по началу работы.",
        "chats": "Чаты",
        "favorites": "Избранное",
        "CHANNELS": "КАНАЛЫ"
    },
    "Comments": {
        "unread_message": "Непрочитанные сообщения",
        "more": "больше",
        "less": "меньше",
        "edited": "отредактировано",
        "edit": "Редактировать",
        "create_task": "Создать задачу",
        "add_to_checklist": "Добавить в чек-лист",
        "copy_message": "Копировать сообщение",
        "reply": "Ответить",
        "message": "Сообщение",
        "mark_unread": "Отметить как непрочитанное",
        "This_message_is_deleted": "Это сообщение удалено",
        "You_deleted_this_message": "Вы удалили это сообщение",
        "no_user_found": "Пользователь не найден",
        "unlock_comment_view": "Для разблокировки просмотра комментариев"
    },
    "PlaceHolder": {
        "enter_task_type": "Введите тип задачи",
        "enter_task_status": "Введите статус задачи",
        "enter_project_status": "Введите статус проекта",
        "Enter_Project_Name": "Введите название проекта",
        "Enter_Key_Name": "Введите название ключа",
        "Select_Category": "Выберите категорию",
        "Select_Project_Due_Date": "Выберите срок проекта",
        "search": "Поиск",
        "search_here": "Ищите здесь",
        "Type_here": "Введите здесь",
        "Task_name": "Название задачи",
        "Add_description": "Добавить описание",
        "Enter_Duplicate_Task_Name": "Введите повторяющееся название задачи",
        "Enter_Text": "Введите текст",
        "Enter_Amount": "Введите сумму",
        "Select": "Выбрать",
        "Enter_Refund_Amount": "Введите сумму возврата",
        "Enter_Milestone_Name": "Введите название этапа",
        "Enter_sprint_name": "Введите название спринта",
        "Enter_directory_name": "Введите название директории",
        "Rename_Tag": "Переименовать тег",
        "Enter_Team_Name": "Введите название команды",
        "Duration_only_hours": "Продолжительность только в часах",
        "Enter_option": "Введите вариант",
        "Enter_View_Name": "Введите название представления",
        "Enter_URL": "Введите URL",
        "Enter_HTML": "Введите HTML",
        "Enter_item_name": "+ Введите название элемента",
        "Add_an_item": "+ Добавить элемент",
        "Enter_Company_Name": "Введите название компании",
        "Select_Country": "Выберите страну",
        "Enter_Template": "Введите шаблон",
        "Enter_Template_Name": "Введите имя шаблона",
        "Project_key_must_be_unique": "Ключ проекта должен быть уникальным",
        "Enter_zip": "Введите почтовый индекс",
        "Enter_GST_Number": "Введите номер GST",
        "Enter_Milestone_Status": "Введите статус этапа",
        "Enter_Priority_Name": "Введите название приоритета",
        "Enter_File_Extensions_Name": "Введите название расширения файла",
        "Enter_Task_Name": "Введите название задачи",
        "Select_State": "Выберите штат",
        "No_States": "Штатов нет",
        "Select_City": "Выберите город",
        "No_Cities": "Города нет",
        "enter_category_name": "Введите название категории",
        "enter_channel_name": "Введите название канала",
        "Pinned_messages": "Закрепленные сообщения",
        "Search": "Поиск",
        "Search_by_name_or_email": "Поиск по имени или email",
        "Invite_by_email": "Пригласить по email",
        "Select_Designation": "Выберите должность",
        "Select_Role": "Выберите роль",
        "Enter_designation": "Введите должность",
        "Enter_Description": "Введите описание",
        "Add_New_Role": "Добавить новую роль",
        "Enter_role": "Введите роль",
        "Enter_Field_Label": "Введите метку поля",
        "Enter_Placeholder": "Введите placeholder",
        "field_label": "Метка поля",
        "placeholder": "Placeholder",
        "Enter_Number": "Введите число"
    },
    "DuplicateTask": {
        "duplicate_task_name": "Дублированное имя задачи",
        "what_do_you_copy": "Что вы хотите скопировать",
        "everything": "Все",
        "no_assignee": "Без исполнителя",
        "no_watcher": "Без наблюдателя",
        "move_task": "Переместить задачу",
        "mearge_task_into": "Объединить задачу в"
    },
    "Converttolist": {
        "are_you_sure_convert": "Вы уверены, что хотите преобразовать эту задачу в список?",
        "important": "Важно",
        "you_will_lose": "Вы потеряете все вложенные комментарии. Это действие невозможно отменить.",
        "convert_to_list": "Преобразовать в список"
    },
    "Billing": {
        "billing_details": "Детали счета",
        "plan_details": "Детали плана",
        "next_msg": "Следующая сумма к оплате",
        "due_on": "Срок оплаты",
        "upgrade_plan": "Обновить план",
        "cancel_subscription": "Отменить подписку",
        "reactivate_subscription": "Восстановить подписку",
        "biling_info": "Информация о платеже",
        "update_billing_info": "Обновить информацию о платеже",
        "contact_support": "Связаться с поддержкой",
        "for_help_msg": "Для получения помощи по вопросам биллинга свяжитесь с нашей службой поддержки, и они с радостью помогут вам.",
        "payment_methods": "Методы оплаты",
        "update_payment_method": "Обновить метод оплаты",
        "add_payment_method": "Добавить способ оплаты",
        "ending_in": "заканчивается",
        "payment_method_update": "Метод оплаты успешно обновлен.",
        "waiting_msg": "Недавнее обновление метода оплаты вступит в силу с вашей следующей оплатой и будет использоваться для всех будущих платежей.",
        "error_updating": "Неудачное обновление метода оплаты. Мы столкнулись с проблемой при обновлении вашего метода оплаты. Пожалуйста, попробуйте снова или свяжитесь с поддержкой.",
        "card_expires": "Карта истекает",
        "billing_address": "Платежный адрес",
        "subscription_plan": "Подписка на план",
        "next_renew_date": "Дата следующего продления",
        "storage_use": "Использование хранилища",
        "address": "Адрес",
        "address_line": "Строка адреса",
        "zip_code": "Почтовый индекс",
        "zip": "Индекс",
        "Save_&_Continue": "Сохранить и продолжить",
        "billing_history": "История платежей",
        "Invoices": "Счета",
        "credit_notes": "Кредитные записки",
        "download": "Скачать",
        "id": "Идентификатор",
        "type": "Тип",
        "date": "Дата",
        "description": "Описание",
        "no_of_users": "Количество пользователей",
        "amount": "Сумма",
        "status": "Статус",
        "pay_now": "Оплатить сейчас",
        "cancelling_subscription_message": "Отмена подписки означает, что ваша подписка заканчивается",
        "reactivate_anytime": "Восстановите подписку в любое время до этой даты!",
        "reactivate_confirmation": "Вы уверены, что хотите восстановить подписку? Нажав 'Да', вы восстановите подписку и возобновите график платежей.",
        "amounting_to": "сумма",
        "insufficient_funds": "Недостаточно средств",
        "payment_successful": "Оплата прошла успешно.",
        "payment_successful_details": "Оплата успешна! Ваш счет оплачен. Пожалуйста, подождите 2-3 минуты, чтобы изменения вступили в силу везде, и вы могли полностью воспользоваться расширенными функциями и улучшениями!",
        "payment_unsuccessful": "Неудачная оплата. Мы столкнулись с проблемой при обновлении вашего плана. Пожалуйста, попробуйте снова или свяжитесь с поддержкой.",
        "plan_upgrade_unsuccessful": "Неудачное обновление плана. Мы столкнулись с проблемой при обновлении вашего плана. Пожалуйста, убедитесь, что на карте достаточно средств.",
        "proceed_with_payment": "Вы хотите продолжить оплату по счету номер",
        "attention_needed": "Нам нужно ваше внимание!",
        "avoid_service_disruption": "чтобы избежать перебоев в обслуживании",
        "subscription_renewal_failed": "Не удалось продлить подписку из-за",
        "update_payment_method_please": "Пожалуйста, обновите метод оплаты",
        "click_here_for_update_payment_method": "Нажмите здесь, чтобы обновить метод оплаты",
        "credit_balance": "Кредитный баланс",
        "this_balance_will_be_used_for_a_future_payment": "Этот баланс будет использован для будущих платежей.",
        "paymnet_failed_subscription_canceled": "Мы хотим сообщить вам, что ваша предыдущая подписка была отменена. Ваш аккаунт был переведен на нашу подписку по умолчанию, в которой некоторые функции отключены. Чтобы включить эти функции, пожалуйста, обновите свой план.",
        "promotional_credit_balance": "Рекламный кредит",
        "balance": "Баланс",
        "created_on": "Создано",
        "no_promotional_found": "История промо-кредитов не найдена"
    },
    "Tour": {
        "tour_completed": "Тур завершён",
        "do_you_have_any": "Есть ли у вас вопросы? Мы рекомендуем вам изучить наши видеоуроки по BRAND_NAME, чтобы начать и максимально эффективно использовать платформу.",
        "watch_video": "Посмотреть видео",
        "have_brief_tour_alianhub": "Пройти краткий тур по BRAND_NAME?",
        "have_brief_tour_alianhub_view": "Пройти краткий тур по просмотрам BRAND_NAME?",
        "have_brief_tour_alianhub_left_side": "Пройти краткий тур по списку проектов?",
        "look_how_to_create": "Посмотрите, как создавать проекты, управлять задачами, просматривать отчёты по временным листам, вести чат, просматривать упоминания и уведомления и многое другое.",
        "lets_start": "Начнём",
        "no_thanks": "Нет, спасибо",
        "have_brief_task": "Пройти краткий тур по задачам?",
        "have_brief_tour_project": "Пройти краткий тур по проекту?",
        "look_how_to_create_task": "Посмотрите, как создать задачу, управлять задачами, просматривать задачи по статусу и многое другое.",
        "look_how_to_create_project": "Посмотрите, как создать проект, управлять проектами, просматривать задачи по статусу и многое другое.",
        "project_creation_description": "Проекты можно легко создавать, назначать и отслеживать, с чёткой видимостью ответственности для участников команды. Это способствует лучшей организации, повышая эффективность и производительность. Нажмите здесь, чтобы создать новый проект.",
        "enter_project_name": "Введите краткое название для вашего проекта.",
        "enter_project_key": "Введите краткий ключ для вашего проекта.",
        "add_project_category": "Добавьте категорию для вашего проекта.",
        "enter_project_duedate": "Введите дату окончания для вашего проекта.",
        "add_project_lead_assignee": "Добавьте основного ответственного за проект.",
        "create_project_from_template": "Эта опция позволяет быстро создать новый проект, используя существующий шаблон, который содержит предустановленные данные и настройки, позволяя легко воспроизвести ту же настройку проекта.",
        "customize_project_section": "Эта опция позволяет полностью настроить ваш проект, установив различные элементы, такие как статусы, типы, приложения и многое другое, в соответствии с вашими потребностями.",
        "task_type_templates_list_text": "Список шаблонов типов задач",
        "task_type_templates_description_text": "В этом разделе отображаются доступные шаблоны типов задач. Выберите тот, который соответствует вашим потребностям.",
        "create_new_task_type_template_text": "Создать новый шаблон типа задачи",
        "create_new_task_type_template_description_text": "Нажмите кнопку +, чтобы добавить новый шаблон типа задачи, который вы сможете использовать для своих задач.",
        "view_template_task_types_text": "Просмотр шаблонов типов задач",
        "view_template_task_types_description_text": "Здесь вы можете увидеть типы задач, связанные с выбранным шаблоном. Вы можете изменить или добавить новые типы задач в зависимости от ваших потребностей.",
        "add_new_task_type_text": "Добавить новый тип задачи",
        "add_new_task_type_description_text": "Нажмите кнопку 'Добавить тип задачи', чтобы включить новые типы задач в выбранный шаблон.",
        "save_project_as_template_text": "Сохранить проект как шаблон",
        "save_project_as_template_description_text": "Нажмите 'Сохранить как шаблон', чтобы сохранить текущую настройку для использования в будущих проектах.",
        "initiate_new_project_text": "Начать новый проект",
        "initiate_new_project_description_text": "Нажмите здесь, чтобы начать новый проект.",
        "add_new_task_text": "Добавить новую задачу",
        "input_task_name_text": "Введите имя задачи",
        "choose_task_status_text": "Выберите статус задачи",
        "assign_task_text": "Назначить задачу",
        "set_task_deadline_text": "Установите срок выполнения задачи",
        "define_task_priority_text": "Установите приоритет задачи",
        "view_task_list_text": "Просмотр списка задач",
        "task_information_text": "Информация о задаче",
        "quick_task_menu_text": "Быстрое меню задач",
        "task_actions_text": "Действия с задачей",
        "subtask_toggle_text": "Переключатель подзадач",
        "task_tour_complete_text": "Тур по задачам завершён",
        "create_new_task_description_text": "Создайте новую задачу, нажав на кнопку '+ Новая задача'.",
        "input_task_name_description_text": "Введите название задачи в предоставленное поле ввода.",
        "choose_task_status_description_text": "Выберите соответствующий тип задачи в зависимости от ваших потребностей.",
        "assign_task_description_text": "Выберите человека, которому будет назначена задача.",
        "set_task_deadline_description_text": "Установите дату завершения задачи.",
        "define_task_priority_description_text": "Выберите уровень приоритета для задачи.",
        "view_task_list_description_text": "Это список задач, отображающий их детали и группированные по статусу.",
        "task_information_description_text": "Здесь отображаются детали для выбранной задачи.",
        "quick_task_menu_description_text": "Нажатие на иконку откроет выпадающее меню с доступными операциями с задачей.",
        "task_actions_description_text": "Выберите операцию из списка доступных действий с задачей.",
        "subtask_toggle_description_text": "Здесь находится переключатель для отображения списка подзадач.",
        "task_tour_complete_description_text": "Тур завершён. Начните исследовать все возможности, которые ждут вас!",
        "search_and_filter_projects_text": "Поиск и фильтрация проектов",
        "search_projects_text": "Поиск проектов",
        "search_options_for_projects_text": "Опции поиска для проектов",
        "search_projects_by_name_text": "Поиск проектов по названию",
        "advanced_project_search_text": "Расширенный поиск проектов",
        "filter_projects_by_favorites_text": "Фильтрация проектов по избранным",
        "project_settings_text": "Настройки проекта",
        "project_list_text": "Список проектов",
        "end_of_project_view_tour_text": "Конец тура по просмотрам проектов",
        "search_and_filter_projects_description_text": "Здесь можно искать и фильтровать проекты по вашим критериям.",
        "enter_search_keywords_text": "Введите ключевые слова для поиска конкретных проектов.",
        "search_filter_dropdown_description_text": "Нажмите на иконку, чтобы открыть выпадающее меню с фильтрами поиска.",
        "toggle_search_options_description_text": "Переключитесь между опциями поиска по проектам, спринтам или папкам, пока вы вводите текст.",
        "advanced_search_icon_description_text": "Нажмите на иконку для выполнения расширенного поиска.",
        "filter_by_favorites_description_text": "Нажмите на иконку звезды, чтобы приоритетно отображать ваши избранные проекты в списке.",
        "project_settings_icon_description_text": "Нажмите на иконку настроек, чтобы переключиться между архивированными или неархивированными проектами.",
        "view_project_list_description_text": "Здесь вы можете просматривать список ваших проектов.",
        "end_of_project_view_tour_description_text": "Тур завершён.",
        "create_assign_prioritize_monitor_projects_text": "Легко создавайте, назначайте, приоритизируйте и отслеживайте проекты. Члены команды могут чётко видеть свои задачи, оставаться организованными и повышать эффективность и продуктивность. Нажмите здесь, чтобы начать новый проект.",
        "track_users_time_sheet_reports_text": "Эффективно отслеживайте время пользователей с помощью различных отчетов по временным листам, таких как отчёты по времени пользователей, проектам, нагрузке и отслеживанию. Нажмите здесь, чтобы изучить отчёты по временным листам.",
        "user_time_sheet_description_text": "Временной лист пользователя позволяет отслеживать часы, потраченные каждым пользователем в зависимости от их роли.",
        "project_time_sheet_description_text": "Отслеживайте количество часов, потраченных на каждый проект, в проектном временном листе в зависимости от роли пользователя.",
        "workload_time_sheet_description_text": "Похож на временной лист пользователя, временной лист нагрузки также включает данные о нагрузке пользователя, общее количество часов и оценочное количество часов.",
        "tracker_sheet_description_text": "Трекер-лист показывает время, отслеженное с помощью трекера времени, а также скриншоты и общее отслеженное время.",
        "view_companies_switch_text": "Посмотрите все компании, с которыми вы связаны, и легко переключайтесь между ними, выбрав одну.",
        "engage_team_real_time_text": "Взаимодействуйте с участниками команды в реальном времени для быстрого принятия решений. Создавайте каналы и делитесь информацией через вложения, голосовые сообщения и текст.",
        "real_time_notifications_text": "Оставайтесь в курсе с помощью уведомлений в реальном времени о действиях по проекту и задачам, включая назначения задач, изменения статусов, комментарии и сроки.",
        "address_specific_individuals_text": "Обращайтесь непосредственно к конкретным лицам в рамках системы управления проектами. Просматривайте упоминания, связанные с задачами, проектами или обсуждениями.",
        "access_personal_information_text": "Доступ к вашей личной информации, а также настройкам, связанным с компаниями, проектами, пользователями и безопасностью, в зависимости от вашей роли.",
        "project_views_list_text": "Список представлений проекта",
        "add_new_project_view_text": "Добавить новое представление проекта",
        "manage_project_views_text": "Управление представлениями проекта",
        "project_files_text": "Файлы проекта",
        "project_audio_files_text": "Аудиофайлы проекта",
        "add_project_watcher_text": "Добавить наблюдателя проекта",
        "project_operation_list_text": "Список операций проекта",
        "advanced_task_filter_text": "Расширенный фильтр задач",
        "search_tasks_text": "Поиск задач",
        "search_options_menu_text": "Меню опций поиска",
        "search_criteria_text": "Критерии поиска",
        "project_views_list_description_text": "Список доступных представлений проекта.",
        "add_new_project_view_description_text": "Создайте новое представление здесь.",
        "manage_project_views_description_text": "Здесь вы можете добавлять или закреплять представления для проекта. Нажмите 'Добавить представление', чтобы добавить, или выберите 'Закрепить представление', чтобы закрепить представление.",
        "project_files_description_text": "Доступ к всем файлам проекта и ссылкам.",
        "project_audio_files_description_text": "Нажмите на иконку, чтобы просмотреть все аудиофайлы, связанные с проектом.",
        "add_project_watcher_description_text": "Управляйте настройками наблюдателя проекта.",
        "project_operation_list_description_text": "Выполняйте различные операции с проектом отсюда.",
        "advanced_task_filter_description_text": "Нажмите на иконку для выполнения расширенного поиска.",
        "search_tasks_description_text": "Введите соответствующие ключевые слова для поиска конкретных задач.",
        "search_options_menu_description_text": "Нажмите на иконку, чтобы открыть выпадающее меню с различными вариантами поиска.",
        "search_criteria_description_text": "Выберите между названием задачи, ключом задачи или описанием, чтобы уточнить поиск.",
        "select_operation_description_text": "Выберите операцию из списка, чтобы выполнить желаемое действие с проектом."
    },
    "TaskStatus": {
        "To_Do": "К выполнению"
    },
    "AI": {
        "generate": "Генерировать",
        "ai_button": "Написать с помощью ИИ",
        "ai_title": "Попросите ИИ найти или создать что-либо",
        "write_with_ai": "Написать с помощью ИИ",
        "suggest_tasks": "Предложить задачи",
        "suggest_subtasks": "Предложить подзадачи",
        "ai_sidebar_placeholder": "О чем вы хотите, чтобы ИИ написал?",
        "ai_chat_placeholder": "Скажите ИИ, что делать дальше",
        "ai_available_on_paid_plans_upgrade_now": "ИИ доступен только на платных планах. Обновите план и добавьте ИИ сейчас!",
        "please_upgrade_plan_to_use_ai": "Пожалуйста, обновите план, чтобы использовать ИИ.",
        "read_less": "Читать меньше",
        "read_more": "Читать больше",
        "to_unlock_ai": "Для разблокировки ИИ",
        "copy": "Копировать",
        "generating_results": "Генерация результатов",
        "hub_ai": "HubAi",
        "regenerate": "Перегенерировать",
        "title": "Заголовок",
        "error_occurred_engine_issue": "Произошла ошибка. Либо запрашиваемый вами движок не существует, либо возникла другая проблема при обработке вашего запроса.",
        "ai_not_integrated": "ИИ не интегрирован в вашу систему",
        "limit_reached": "Вы достигли своего лимита"
    },
    "Toast": {
        "Your_card_is_expired": "Срок действия вашей карты истёк.",
        "Password_set_new_has_been_successfully": "Новый пароль успешно установлен.",
        "task_created_successfully": "Задача успешно создана",
        "please_remove_the_advanced_filter_to_view_newly_created_projects": ", Пожалуйста, снимите расширенный фильтр, чтобы просматривать недавно созданные проекты.",
        "create_task_plan_limit_message": "Обновите свой план. Вы достигли лимита на создание задач в спринте TASK_SPRINT.",
        "something_went_wrong": "Что-то пошло не так.",
        "file_size_is_larger_than_maxFileSize": "Размер файла больше максимального допустимого размера",
        "Select_image_only_and_image_file_format_should_be_FILE_FORMATS": "Выберите только изображение, и формат файла должен быть FILE_FORMATS",
        "Select_file_only_image_and_image_file_format_should_be_FILE_FORMATS": "Выберите только файл изображения, и формат файла должен быть FILE_FORMATS",
        "Multiple_files_not_allowed": "Множественные файлы не разрешены.",
        "Please_select_valid_file": "Пожалуйста, выберите допустимый файл.",
        "require_image_format_message": "Формат файла не поддерживается или не добавлен в настройки компании. Вы можете добавить формат файла в Настройках.",
        "You_have_to_add_extension_in_setting": "Вы должны добавить расширение в настройках.",
        "Something_went_wrong_Please_try_again": "Что-то пошло не так. Пожалуйста, попробуйте снова.",
        "Company_is_disable": "Компания отключена",
        "advance_search_feature_upgrade_message": "Функция расширенного поиска недоступна на вашем текущем плане. Чтобы разблокировать расширенный поиск, обновите свой план.",
        "Access_Denied": "Доступ запрещен",
        "notification_permission": "Для получения уведомлений, пожалуйста, разрешите уведомления в настройках сайта и перезагрузите страницу.",
        "Link_is_Copied_to_clipboard": "Ссылка скопирована в буфер обмена",
        "Task_Key_is_Copied_to_clipboard": "Ключ задачи скопирован в буфер обмена",
        "At_least_one_field_is_required": "Необходимо заполнить хотя бы одно поле.",
        "Task_name_updated_successfully": "Имя задачи успешно обновлено",
        "Watcher_added_successfully": "Наблюдатель успешно добавлен",
        "Watcher_removed_successfully": "Наблюдатель успешно удален",
        "Nothing_to_update": "Нет ничего для обновления",
        "Sprint created successfully": "Спринт успешно создан",
        "Sprint restored successfully": "Спринт успешно восстановлен",
        "Sprint closed successfully": "Спринт успешно закрыт",
        "Sprint archived successfully": "Спринт успешно архивирован",
        "Sprint deleted successfully": "Спринт успешно удален",
        "Upgrade_your_plan_you_have_reached_the_limit_for_creating_sprints": "Обновите план. Вы достигли лимита на создание спринтов.",
        "Folder created successfully": "Папка успешно создана",
        "Folder updated successfully": "Папка успешно обновлена",
        "Folde restored successfully": "Папка успешно восстановлена",
        "Folder closed successfully": "Папка успешно закрыта",
        "Folder archived successfully": "Папка успешно архивирована",
        "Folder deleted successfully": "Папка успешно удалена",
        "Status_changed_successfully": "Статус успешно изменен",
        "Due_date_updated_successfully": "Срок выполнения успешно обновлен",
        "Due_date_not_updated": "Срок выполнения не обновлен",
        "Assignee changed_ uccessfully": "Ответственный успешно изменен",
        "Assignee added successfully": "Ответственный успешно добавлен",
        "Assignee removed successfully": "Ответственный успешно удален",
        "Assignee not updated": "Ответственный не обновлен",
        "Task_updated_successfully": "Задача успешно обновлена",
        "Task_restored_successfully": "Задача успешно восстановлена",
        "Task_archived_successfully": "Задача успешно архивирована",
        "Task_deleted_successfully": "Задача успешно удалена",
        "Tag_Deleted_successfully": "Метка успешно удалена",
        "Log_time_added_successfully": "Время успешно добавлено.",
        "Filter_saved_successfully": "Фильтр успешно сохранен.",
        "Filter_update_successfully": "Фильтр успешно обновлен.",
        "Filter_deleted_successfully": "Фильтр успешно удален.",
        "Checklist_creted_succesfully.": "Чеклист успешно создан.",
        "Please_select_checklist": "Пожалуйста, выберите чеклист.",
        "already_exists": "EXIST_VALUE уже существует",
        "Converted_sucessfully": "Успешно преобразовано",
        "create_task_limit_in_sprint_upgrade_task_message": "Обновите план. Вы достигли лимита на создание задач в спринте SELECTED_SPRINT_DATA.",
        "Please_Select_Task_Type": "Пожалуйста, выберите тип задачи",
        "Please_Select_Task": "Пожалуйста, выберите задачу",
        "Task_moved_sucessfully": "Задача успешно перемещена",
        "Task_not_moved": "Задача не перемещена",
        "Task_duplicate_sucessfully": "Задача успешно дублирована",
        "Task_not_duplicated": "Задача не была продублирована",
        "Convert_in_to_task_sucessfully": "Успешно преобразовано в задачу",
        "Company_name_already_exists": "Компания с таким именем уже существует",
        "Company_has_been_created_Successfully": "Компания успешно создана.",
        "Custom_field_updated_successfully": "Пользовательское поле успешно обновлено",
        "No_assignee_found": "Ответственный не найден",
        "No_due_date_found": "Срок выполнения не найден",
        "No_self_assignee_found": "Самоответственный не найден",
        "Estimated_time_updated_successfully": "Ожидаемое время успешно обновлено",
        "Description_updated_successfully": "Описание успешно обновлено",
        "Description_not_updated": "Описание не обновлено",
        "Copied": "Скопировано!",
        "User_removed_successfully": "Пользователь успешно удален",
        "Invitation_cancelled_successfully": "Приглашение успешно отменено",
        "User_role_changed_successfully": "Роль пользователя успешно изменена",
        "User_designation_changed_successfully": "Должность пользователя успешно изменена.",
        "Please_upgrade_your_plan_to_use_Time_Tracker": "Пожалуйста, обновите план для использования трекера времени.",
        "Request_remove_successfully": "Запрос успешно удален",
        "Upgrade_Your_Plan": "Обновите свой план",
        "Updated_successfully": "Успешно обновлено",
        "Deleted_successfully": "Успешно удалено",
        "View_Pinned": "Просмотр закрепленных",
        "View_Unpinned": "Просмотр открепленных",
        "View_Already_Added": "Просмотр уже добавленных",
        "Company_details_saved_successfully": "Данные компании успешно сохранены.",
        "Currency_added_successfully": "Валюта успешно добавлена",
        "Currency_removed_successfully": "Валюта успешно удалена",
        "File_extension_remove_successfully": "Расширение файла FILE_EXTENSION успешно удалено",
        "File_extension_update_successfully": "Расширение файла успешно обновлено.",
        "Status_updated_successfully": "Статус успешно обновлен",
        "Project_milestone_status_Deleted_successfully": "Статус вехи проекта успешно удален.",
        "Milestone_weekly_range_updated_successfully": "Еженедельный диапазон вехи успешно обновлен.",
        "Image_dimensions_should_not_exceed_ImageDimensions_pixels": "Размеры изображения не должны превышать ImageDimensions пикселей.",
        "error_in_uploading_image_please_try_it_again": "Ошибка загрузки изображения. Пожалуйста, попробуйте снова",
        "Task_priority_updated_successfully": "Приоритет задачи успешно обновлен.",
        "Task_priority_Remove_successfully": "Приоритет задачи успешно удален.",
        "Priority_updated_successfully": "Приоритет успешно обновлен",
        "Priority_not_updated": "Приоритет не обновлен",
        "error_in_deleting_priority_please_try_it_again": "Ошибка при удалении приоритета. Пожалуйста, попробуйте снова",
        "Field_Enable_Successfully": "Поле успешно включено",
        "Field_Disable_Successfully": "Поле успешно отключено",
        "Field_Added_Successfully": "Поле успешно добавлено",
        "Field_Updated_Successfully": "Поле успешно обновлено",
        "Added_to_favourite": "Добавлено в избранное",
        "Removed_from_favourite": "Удалено из избранного",
        "Tag_Created_successfully": "Метка успешно создана",
        "Queue list added successfully": "Список очереди успешно добавлен",
        "Queue list removed successfully": "Список очереди успешно удален",
        "Queue list not updated": "Список очереди не обновлен",
        "Attachments_uploaded_successfully": "Вложения успешно загружены",
        "Attachment_removed_successfully": "Вложение успешно удалено",
        "Attachment_not_removed": "Вложение не удалено",
        "Please_try_again": "Пожалуйста, попробуйте снова",
        "Task_name_copied": "Имя задачи скопировано",
        "Status_already_exists": "Статус уже существует",
        "Status_added_sucessfully": "Статус успешно добавлен",
        "Task_Type_already_exists": "Тип задачи уже существует",
        "Task_Type_added_sucessfully": "Тип задачи успешно добавлен",
        "Image_size_must_be_less_than_ImageDimensions_pixels": "Размер изображения должен быть меньше ImageDimensions пикселей.",
        "Data_deleted_successfully": "Данные успешно удалены.",
        "Category_created_successfully": "Категория успешно создана",
        "Please_select_an_image_file": "Пожалуйста, выберите файл изображения",
        "Channel_created_successfully": "Канал успешно создан",
        "Folder_not_found": "Папка не найдена",
        "Template_&_Project_data_has_been_added_successfully": "Шаблон и данные проекта успешно добавлены.",
        "Project_data_has_been_added_successfully": "Данные проекта успешно добавлены{filterMessage}",
        "Error_in_creating_project": "Ошибка при создании проекта",
        "Milestone_deleted_successfully": "Веха успешно удалена",
        "Error_in_deleting_milestone": "Ошибка при удалении вехи",
        "Milestone_added_successfully": "Веха успешно добавлена",
        "Error_in_adding_milestone": "Ошибка при добавлении вехи",
        "Milestone_update_successfully": "Веха успешно обновлена",
        "Error_in_updating_milestone": "Ошибка при обновлении вехи",
        "Milestone_status_update_successfully": "Статус вехи успешно обновлен",
        "Error_in_updating_milestone_status": "Ошибка при обновлении статуса вехи",
        "Milestone_refund_amount_update_successfully": "Сумма возврата для вехи успешно обновлена",
        "Error_in_updating_milestone_refund_amount": "Ошибка при обновлении суммы возврата для вехи",
        "The_project_not_found": "Проект не найден.",
        "The_project_is_archived": "Проект архивирован.",
        "Start_date_of_project_should_be_smaller_than_current_date": "Дата начала проекта должна быть раньше текущей даты",
        "All_the_range_is_included_in_milestone": "Весь диапазон включен в веху",
        "Please_enter_start_date_of_project": "Пожалуйста, введите дату начала проекта",
        "Project_name_updated_successfully": "Имя проекта успешно обновлено",
        "Project restored successfully": "Проект успешно восстановлен",
        "Project closed successfully": "Проект успешно закрыт",
        "Project archived successfully": "Проект успешно архивирован",
        "Project deleted successfully": "Проект успешно удален",
        "Enter_valid_project_source": "Введите действительный источник проекта",
        "Please_select_sub_task": "Пожалуйста, выберите подзадачу.",
        "Status_not_updated": "Статус не обновлен",
        "Start_date_updated_successfully": "Дата начала успешно обновлена",
        "Start_date_not_updated": "Дата начала не обновлена",
        "Task_converted_sucessfully": "Задача успешно преобразована",
        "Task_merged_sucessfully": "Задача успешно объединена",
        "Can_not_create_template_name_Custom": "Невозможно создать шаблон с именем 'Custom'",
        "Template_name_updated_successfully": "Имя шаблона успешно обновлено.",
        "Template_has_been_created_Successfully": "Шаблон был успешно создан.",
        "Template_deleted_successfull": "Шаблон успешно удален.",
        "Template_has_been_deleted_successfully": "Шаблон был успешно удален.",
        "Storage_exceeded_Upgrade_your_plan": "Превышен лимит хранилища. Обновите ваш тарифный план.",
        "max_filesize_messages": "Максимальный размер файла составляет FILE_SIZE МБ.",
        "Password_reset_email_has_been_sent_successfully": "Письмо для сброса пароля успешно отправлено",
        "Invalid_username_or_password": "Неверное имя пользователя или пароль.",
        "Email_Not_Verified": "Email не подтвержден.",
        "Verification_mail_has_been_send_successfully": "Письмо для подтверждения было успешно отправлено",
        "Invalid_url": "Неверный URL",
        "User_already_registered": "Пользователь уже зарегистрирован.",
        "User_has_been_registered_successfully": "Пользователь был успешно зарегистрирован.",
        "The_email_address_is_already_in_use": "Этот адрес электронной почты уже используется",
        "User_has_been_registered_successfully_Please_verify_your_email_to_continue": "Пользователь был успешно зарегистрирован, пожалуйста, подтвердите ваш email, чтобы продолжить.",
        "Password_reset_has_been_successfully": "Пароль был успешно сброшен",
        "Your_email_has_been_verify_successfully": "Ваш email был успешно подтвержден",
        "Invitation_accepted_successfully": "Приглашение успешно принято",
        "Only_product_owner_can_create_a_company": "Только владелец продукта может создать компанию",
        "Company_name_must_be_unique": "Имя компании должно быть уникальным.",
        "Subscription_cancel_succesfully_Please_allow_2_to_3_minutes_for_the_changes_to_take_effect_everywhere": "Подписка успешно отменена. Пожалуйста, подождите 2-3 минуты, чтобы изменения вступили в силу.",
        "Subscription_reactivate_succesfully_Please_allow_2_to_3_minutes_for_the_changes_to_take_effect_everywhere": "Подписка успешно восстановлена. Пожалуйста, подождите 2-3 минуты, чтобы изменения вступили в силу.",
        "View_name_is_required": "Необходимо указать имя представления",
        "name_should_be_at_least_3_characters_long": "Имя должно содержать хотя бы 3 символа",
        "View_name_already_exists": "Имя представления уже существует",
        "View_added_successfully": "Представление успешно добавлено",
        "View_Deleted_Successfully": "Представление успешно удалено",
        "Link_copied_to_clipboard_successfully": "Ссылка успешно скопирована в буфер обмена",
        "Project_avatar_updated_successfully": "Аватар проекта успешно обновлен",
        "Message pinned successfully": "Сообщение успешно закреплено",
        "Message unpinned successfully": "Сообщение успешно откреплено",
        "Message_copied": "Сообщение скопировано",
        "Item_cannot_be_empty": "Элемент не может быть пустым",
        "Maximum_MAX_CHAR_characters_are_allowed": "Допустимо максимум MAX_CHAR символов",
        "Item_added_to_checklist": "Элемент добавлен в контрольный список",
        "Maximum_10_files_can_be_uploaded_at_once": "Можно загрузить не более 10 файлов за раз",
        "file_type_is_not_supported": "Тип файла не поддерживается!",
        "ERROR_in_file_upload": "Ошибка при загрузке файла",
        "file_size_is_larger_than_FILE_SIZE_mb": "Размер файла больше FILE_SIZE МБ!",
        "Mark_as_favorite_successfully": "Успешно добавлено в избранное",
        "Start_and_Due_date_updated_successfully": "Дата начала и окончания успешно обновлены",
        "Start_and_Due_date_not_updated": "Дата начала и окончания не обновлены",
        "Attchments_deleted_successfully": "Вложения успешно удалены",
        "Designation_is_required": "Необходима должность",
        "Designation_already_exists": "Должность уже существует",
        "Designation_added_successfully": "Должность успешно добавлена",
        "Designation_updated_successfully": "Должность успешно обновлена",
        "Role_is_required": "Необходима роль",
        "Role_already_exists": "Роль уже существует",
        "Role_added_successfully": "Роль успешно добавлена",
        "Role_updated_successfully": "Роль успешно обновлена",
        "Please_provide_an_email_id": "Пожалуйста, укажите email",
        "Please_provide_a_designation": "Пожалуйста, укажите должность",
        "Please_provide_a_role": "Пожалуйста, укажите роль",
        "Designation_deleted_successfully": "Должность успешно удалена",
        "The_role_is_already_in_use_so_it_can't_be_deleted": "Роль уже используется, поэтому ее нельзя удалить.",
        "Role_deleted_successfully": "Роль успешно удалена",
        "Language_not_updated": "Язык не обновлен!",
        "Profile_updated_successfully": "Профиль успешно обновлен.",
        "Notification_Settings_Update_successfully": "Настройки уведомлений успешно обновлены",
        "Permission_updated_successfully": "Права успешно обновлены",
        "Per_User_Generate_Limit_value_is_not_valid": "Значение лимита генерации на пользователя неверно",
        "Team_name_is_required": "Необходимо указать название команды",
        "Minimum_3_character_required": "Необходимо минимум 3 символа",
        "Team_name_already_exist": "Название команды уже существует",
        "Template_has_been_added_successfully": "Шаблон был успешно добавлен.",
        "Billing_details_has_been_updated_successfully": "Платежные данные были успешно обновлены",
        "Billing_details_not_updated": "Платежные данные не обновлены",
        "Invalid_Card_Details_Please_check_and_try_again": "Неверные данные карты. Пожалуйста, проверьте и попробуйте снова.",
        "Expired_Card_Please_check_and_try_again": "Истек срок действия карты. Пожалуйста, проверьте и попробуйте снова.",
        "Invalid_card_verification_code_(CVC)_Please_check_and_try_again": "Неверный код проверки карты (CVC). Пожалуйста, проверьте и попробуйте снова.",
        "You_have_cancel_your_current_subscription_at_term_end_please_reactivate_subscription_and_try_again": "Вы отменили свою текущую подписку по окончании срока. Пожалуйста, восстановите подписку и попробуйте снова.",
        "Plan_not_purchased_Please_try_again": "План не куплен. Пожалуйста, попробуйте снова.",
        "Please_fill_out_billing_details_first": "Пожалуйста, заполните платежные данные сначала.",
        "Please_check_your_credential": "Пожалуйста, проверьте ваши данные для входа.",
        "File_type_not_supported": "Тип файла не поддерживается",
        "Are_you_sure_to_delete_this_file": "Вы уверены, что хотите удалить этот файл?",
        "Select_Project_Type": "Выберите тип проекта",
        "Tracker_user_added_successfully": "Пользователь отслеживания успешно добавлен",
        "Tracker_user_removed_successfully": "Пользователь отслеживания успешно удален",
        "queue_list_not_updated": "Список очереди не обновлен.",
        "upgrade_plan_folder_limit_reached": "Обновите ваш тарифный план. Вы достигли лимита на создание папок",
        "View_updated_successfully": "Представление успешно обновлено",
        "The_designation_is_already_in_use_so_it_cant_be_deleted": "Должность уже используется, поэтому ее нельзя удалить",
        "Sprint_already_exists": "Спринт уже существует",
        "Folder_already_exists": "Папка уже существует",
        "Sprint updated successfully": "Спринт успешно обновлен",
        "Project_milestone_status_updated_successfully": "Статус вехи проекта успешно обновлен.",
        "Invalid_email": "Ваш адрес электронной почты недействителен. Пожалуйста, проверьте и попробуйте еще раз",
        "Invalid_password": "Ваш пароль недействителен. Пожалуйста, проверьте и попробуйте еще раз",
        "Too_many_request": "Слишком много запросов. Пожалуйста, повторите попытку позже",
        "Password_reset_link": "Электронное письмо о сроке действия пароля успешно отправлено! Пожалуйста, проверьте свой почтовый ящик, чтобы продолжить сброс пароля.",
        "Project_milestone_status_added_successfully": "Статус этапа проекта успешно добавлен.",
        "Please_select_start_end_date": "Пожалуйста, выберите дату начала и окончания",
        "Invitation_canceled": "Приглашение отменено: Вы больше не можете использовать эту ссылку",
        "Ai_limit_reached": "Ваш дневной лимит достигнут.",
        "You_have_reached_the_maximum_limit_of_guest_users": "Обновите свой план. Вы достигли максимального лимита гостевых пользователей.",
        "Upgrade_for_import": "Обновите свой план, чтобы получить доступ к функции импорта.",
        "Upgrade_for_export": "Обновите свой план, чтобы получить доступ к функции экспорта.",
        "import_task_success": "Ваши задачи были успешно импортированы.",
        "export_task_success": "Задачи успешно экспортированы.",
        "export_task_error": "Нет задач для экспорта.",
        "invalid_file_error": "Неверный тип файла. Пожалуйста, загрузите файл .csv.",
        "free_company_limit_reached": "Вы достигли максимального лимита на создание бесплатных компаний.",
        "Import_users_successfully": "Пользователи успешно импортированы",
        "date_range": "Пожалуйста, выберите диапазон дат перед применением.",
        "Task_total_estimate_update_succesfull": "Обновление общей оценки задачи успешно"
    },
    "SecurityAndPermission": {
        "project": "Проект",
        "project_list": "Список проектов",
        "project_create": "Создание проекта",
        "project_name_edit": "Редактирование названия проекта",
        "project_sprint_create": "Создание спринта проекта",
        "project_folder_create": "Создание папки проекта",
        "project_folder_name_edit": "Редактирование названия папки проекта",
        "project_sprint_name_edit": "Редактирование названия спринта проекта",
        "project_details": "Детали проекта",
        "project_status_change": "Изменение статуса проекта",
        "project_assignee": "Назначение проекта",
        "project_category": "Категория проекта",
        "project_source": "Источник проекта",
        "project_type": "Тип проекта",
        "project_currency": "Валюта проекта",
        "project_amount": "Сумма проекта",
        "project_start_date": "Дата начала проекта",
        "project_end_date": "Дата окончания проекта",
        "project_due_date": "Дата завершения проекта",
        "project_close": "Закрытие проекта",
        "project_description": "Описание проекта",
        "project_checklist": "Контрольный список проекта",
        "project_checklist_assign_remove": "Назначение/удаление контрольного списка проекта",
        "project_attachments": "Вложения проекта",
        "project_milestone": "Этап проекта",
        "task": "Задача",
        "task_list": "Список задач",
        "task_create": "Создание задачи",
        "sub_task_create": "Создание подзадачи",
        "task_name_edit": "Редактирование названия задачи",
        "task_status": "Статус задачи",
        "task_assignee": "Назначение задачи",
        "task_priority": "Приоритет задачи",
        "task_due_date": "Дата завершения задачи",
        "task_estimated_hours": "Оценочное количество часов задачи",
        "task_description": "Описание задачи",
        "task_checklist": "Контрольный список задачи",
        "task_checklist_assign_remove": "Назначение/удаление контрольного списка задачи",
        "task_attachments": "Вложения задачи",
        "show_tasks": "Показать задачи",
        "task_custom_field": "Пользовательское поле",
        "settings": "Настройки компании",
        "settings_edit_company": "Редактировать компанию",
        "settings_task_priority": "Приоритет задач",
        "settings_file_extensions": "Расширения файлов",
        "settings_project_milestone_status": "Статус этапа проекта",
        "settings_invite_member": "Пригласить участника",
        "settings_member_list": "Список участников",
        "settings_create_team": "Создать команду",
        "settings_team_list": "Список команд",
        "settings_project_list": "Список проектов",
        "settings_security_permissions": "Безопасность и разрешения",
        "settings_role_management": "Управление ролями",
        "settings_designation": "Должность",
        "milestone_weekly_range": "Еженедельный диапазон этапа",
        "settings_custom_field": "Пользовательское поле",
        "sheet_settings": "Настройки таблиц",
        "user_timesheet": "Табель учёта рабочего времени пользователя",
        "project_timesheet": "Табель учёта рабочего времени проекта",
        "workload_timesheet": "Табель учёта рабочего времени по нагрузке",
        "milestone_report": "Отчет по этапам",
        "artificial_intelligence": "Искусственный интеллект",
        "per_user_generate_limit": "Лимит токенов на пользователя",
        "project_custom_field": "Пользовательское поле проекта",
        "public_projects": "Общий список проектов",
        "tracker_timesheet": "Табель учёта рабочего времени трекера",
        "view_list": "Просмотреть список",
        "chat": "Чат",
        "project_delete": "Удаление проекта",
        "folder_archive": "Архивирование папки",
        "folder_delete": "Удаление папки",
        "folder_restore": "Восстановление папки",
        "sprint_type_change": "Изменение типа спринта",
        "sprint_restore": "Восстановление спринта",
        "sprint_delete": "Удаление спринта",
        "sprint_archive": "Архивирование спринта",
        "chat_channel": "Создать канал чата",
        "chat_category": "Создать категорию чата",
        "one_to_one_chat": "Один на один чат",
        "task_tag": "Тег задачи",
        "task_start_date": "Дата начала задачи",
        "task_activity_log": "Журнал активности задачи",
        "task_convert_to_list": "Преобразовать задачу в список",
        "task_convert_to_subtask": "Преобразовать задачу в подзадачу",
        "task_duplicate": "Дублировать задачу",
        "task_merge": "Объединить задачу",
        "task_move": "Переместить задачу",
        "task_archive": "Архивировать задачу",
        "task_delete": "Удалить задачу",
        "task_comment": "Комментарий к задаче",
        "task_details": "Детали задачи",
        "queue_list": "Список очереди",
        "advance_search": "Расширенный поиск",
        "list_view_column": "Колонка представления списка",
        "task_type": "Aufgabentyp",
        "import_tasks": "Импорт задач",
        "export_tasks": "Экспорт задач",
        "convert_to_task": "Преобразовать в задачу"
    },
    "general": {
        "Continue": "Продолжить",
        "New_Status": "Новый статус",
        "Old_Status": "Старый статус",
        "Old_Task_Type": "Старый тип задачи",
        "New_Task_Type": "Новый тип задачи",
        "New_Task_Assignee": "Новый назначенный исполнитель задачи",
        "Old_Task_Assignee": "Старый назначенный исполнитель задачи",
        "New_Task_Watchers": "Новые наблюдатели задачи",
        "Old_Task_Watchers": "Старые наблюдатели задачи",
        "Select_Status": "Выберите статус",
        "Select_Task_Type": "Выберите тип задачи",
        "No_Assignee": "Нет назначенного исполнителя",
        "No_Watchers": "Нет наблюдателей",
        "Different_Statuses": "Разные статусы",
        "Please_Select_Status": "Пожалуйста, выберите статус",
        "Tomorrow": "Завтра",
        "Yesterday": "Вчера",
        "Project": "Проект",
        "Team": "Команда",
        "User": "Пользователь",
        "Copy_Assignees": "Копировать назначенных исполнителей",
        "Copy_Watchers": "Копировать наблюдателей",
        "apply": "Применить",
        "current_month": "Текущий месяц",
        "current_week": "Текущая неделя",
        "keyboard": "Клавиатура",
        "mouse": "Мышь",
        "Create": "Создать",
        "scroll_to_bottom": "Прокрутить вниз",
        "unassigned": "Не назначено",
        "entries": "записи",
        "showing": "Показано",
        "page_not_found": "Упс, страница не найдена",
        "page_not_found_description": "Извините за неудобства. Похоже, вы пытаетесь получить доступ к странице, которая была удалена или никогда не существовала.",
        "note": "Заметка",
        "settings_change_no_effect": "Изменения нижеприведённых настроек не повлияют на текущие значения полей, если они не пустые",
        "advanced": "Продвинутые",
        "general": "Основные",
        "limits": "Ограничения",
        "message_deleted": "Сообщение удалено",
        "company_individual": "Название компании/индивидуала",
        "enter_company_individual": "Введите название компании/имя физического лица"
    },
    "monthName": {
        "jan": "Янв",
        "feb": "Фев",
        "mar": "Мар",
        "apr": "Апр",
        "may": "Май",
        "jun": "Июн",
        "jul": "Июл",
        "aug": "Авг",
        "sep": "Сен",
        "oct": "Окт",
        "nov": "Ноя",
        "dec": "Дек"
    },
    "timeLog": {
        "start_time_field_required": "Поле начала времени обязательно для заполнения",
        "end_time_field_required": "Поле окончания времени обязательно для заполнения",
        "select_valid_time_duration": "Пожалуйста, выберите правильную продолжительность времени"
    },
    "weekName": {
        "sun": "Вс",
        "mon": "Пн",
        "tue": "Вт",
        "wed": "Ср",
        "thu": "Чт",
        "fri": "Пт",
        "sat": "Сб",
        "fridays": "Пятницы",
        "mondays": "Понедельники",
        "saturdays": "Субботы",
        "sundays": "Воскресенья",
        "thursdays": "Четверги",
        "tuesdays": "Вторники",
        "wednesdays": "Среды"
    },
    "tooltipText": {
        "enable_app_manage_priority": "Включив это приложение, вы сможете управлять <b>Приоритетом</b> в <b>Задачах</b> для этого <b>проекта</b>",
        "enable_app_manage_multiple_assignee": "Включив это приложение, вы сможете управлять <b>Несколькими исполнителями</b> в <b>Задачах</b> для этого <b>проекта</b>",
        "enable_app_manage_time_estimates": "Включив это приложение, вы сможете управлять <b>Оценками времени</b> в <b>Задачах</b> для этого <b>проекта</b>",
        "enable_app_manage_tags": "Включив это приложение, вы сможете управлять <b>Тегами</b> в <b>Задачах</b> для этого <b>проекта</b>",
        "enable_app_use_milestones": "Включив это приложение, вы сможете использовать <b>Этапы</b> для этого <b>проекта</b>",
        "enable_app_use_ai_operations": "Включив это приложение, вы сможете использовать <b>Операции ИИ</b> для этого <b>проекта</b>",
        "enable_app_manage_time_log": "Включив это приложение, вы сможете управлять <b>Журналом времени</b> в <b>Задачах</b> для этого <b>проекта</b>",
        "enable_app_manage_custom_fields": "Включив это приложение, вы сможете управлять <b>Пользовательскими полями</b> для этого <b>проекта</b>"
    },
    "Company": {
        "fill_company_details": "Заполните данные вашей компании",
        "set_up_company": "Настройка вашей компании",
        "creating_company": "Создание компании",
        "company_created": "Ваша компания была создана. Мы настроили начальные шаги. Пожалуйста, подождите немного.",
        "good_to_go": "Готово к работе",
        "select_default_country": "Выберите страну по умолчанию",
        "freelimitreachedstart": "Вы уже создали бесплатную компанию. Чтобы создать новую компанию, вам необходимо сначала перейти на платный план",
        "freelimitreachedend": "После обновления вы сможете добавить еще одну бесплатную компанию."
    },
    "Subscription": {
        "subscription_cancelled": "Вы отменили свою подписку в конце текущего периода подписки",
        "discard_changes": "Пользователь вашей подписки отменит эти изменения, и ваша текущая подписка продолжится с следующего расчетного периода.",
        "confirm_terminate_schedule": "Вы уверены, что хотите отменить запланированное прекращение подписки?",
        "confirm_add_user": "Вы уверены, что хотите добавить пользователя в вашу подписку?",
        "confirm_remove_user": "Вы уверены, что хотите удалить пользователя из подписки?",
        "next_invoice_amount": "Ваш следующий счет составит",
        "credits_applied": "Примененные кредиты",
        "current_billing_for_upgrade": "Текущая оплата за обновление",
        "plan_upgrade_success": "Поздравляем! Ваше обновление плана было успешно запланировано, и улучшения вступят в силу после окончания текущего периода. Готовьтесь к новым функциям и преимуществам в следующей фазе вашей подписки.",
        "subscription_upgrade_from": "Ваша подписка будет обновлена с",
        "total_payable_amount": "Общая сумма к оплате",
        "update_subscription": "Обновить подписку",
        "updated_subscription_price": "Обновленная цена подписки",
        "upgrade_subscription": "Обновить подписку",
        "confirm_subscription_change": "Вы уверены, что хотите изменить вашу подписку с",
        "monthly": "Месяц",
        "yearly": "Год",
        "remove_scheduled_cancellation_confirmation": "Нажав 'Да', вы удалите запланированное прекращение подписки, и ваш расчетный период продолжится.",
        "scheduled_cancellation_notice": "У вас запланирована отмена подписки на",
        "credit_entitlement_congratulations": "Поздравляем! Вы имеете право на кредит в размере",
        "credit_note_application": "для вашей текущей подписки. Этот кредит будет автоматически применен для улучшения вашей подписки, а также будет вычтен из ваших предстоящих счетов, что обеспечит постоянную ценность и экономию для вашего подписочного пути.",
        "invoice_period_coverage": "Счет покрывает период с"
    },
    "Card": {
        "pay_with": "Оплатить с помощью",
        "add_new_card": "Добавить новую карту",
        "name_on_card": "Имя на карте",
        "card_number": "Номер карты",
        "expiry": "Срок действия",
        "cvc": "CVC"
    },
    "alertBox": {
        "updateBillingAddress": "Вам нужно обновить первый платежный адрес",
        "valid_csv_title": "Файл не загружен",
        "valid_csv_text": "Пожалуйста, загрузите допустимый .csv файл, чтобы продолжить.",
        "ok": "ОК",
        "cancel": "Отмена",
        "go_back_title": "Вернуться назад?",
        "go_back_text": "Вы действительно хотите вернуться к предыдущему шагу?",
        "close_modal_title": "Закрыть модальное окно?",
        "close_modal_text": "Вы действительно хотите закрыть модальное окно? Вся информация, введённая до этого шага, будет утеряна.",
        "no": "Нет",
        "yes": "Да",
        "confirm": "Подтвердить",
        "improper_header_selection_title": "Неверный выбор",
        "improper_header_selection_text": "Выбранная строка содержит значения, не являющиеся строками. Пожалуйста, выберите другую строку.",
        "missing_fields_title": "Отсутствуют обязательные поля",
        "missing_fields_text": "Перед продолжением необходимо сопоставить и подтвердить обязательные поля.",
        "warning_title": "Предупреждение",
        "warning_text": "Если вы продолжите, пустые значения в 'Приоритете задачи' и 'Статусе' будут автоматически установлены в 'Средний' и 'К выполнению' соответственно.",
        "incomplete_mapping_title": "Неполное сопоставление",
        "incomplete_mapping_text": "Для продолжения сопоставьте все уникальные значения хотя бы с одним значением Hyphen OI Pro.",
        "invalid_tasks_error": "Не найдено действительных задач. Убедитесь, что обязательные поля не пусты."
    },
    "importTaskButton": {
        "import_title": "Импорт задач",
        "import_button": "Импортировать задачи из CSV",
        "back_button": "Назад",
        "next_button": "Далее",
        "export_button": "Экспортировать как CSV",
        "import_processing": "Ваши задачи импортируются."
    },
    "importCsvAndSetHeader": {
        "download": "Скачать",
        "demo_csv": "Демо CSV",
        "down_demo_text": "Сравните файл с вашим импортируемым файлом, чтобы убедиться, что он корректен.",
        "upload_button": "Загрузите ваш CSV-файл здесь",
        "upload_instructions": "Вы можете загрузить любой .csv файл с любыми столбцами, где каждая строка представляет собой запись. На следующем шаге вы сможете сопоставить столбцы вашей таблицы с соответствующими точками данных. Перед окончательным импортом можно удалить или исправить некорректные данные.",
        "header_row_question": "Содержит ли выбранная строка заголовки столбцов?",
        "select_another_button": "Выбрать другую строку",
        "confirm_row_btt": "Подтвердить"
    },
    "headerMapping": {
        "title": "Сопоставление заголовков",
        "mapping_instructions": "Давайте сопоставим ваши заголовки с заголовками Hyphen OI Pro",
        "pending_count": "Оставшиеся поля:",
        "confirmed_count": "Подтверждённые поля:",
        "ignored_count": "Игнорируемые поля:",
        "custom_count": "Пользовательские поля:",
        "confirmed_text": "Подтверждено",
        "ignored_text": "Игнорируется",
        "edit_button": "Редактировать",
        "no_match_title": "Нет совпадений",
        "no_match": "Совпадений не найдено",
        "no_match_description": "Это поле не совпадает с заголовками Hyphen OI Pro. Вы можете его игнорировать или добавить как пользовательское поле.",
        "custom_field_button": "Добавить как пользовательское поле",
        "ignore_field_button": "Игнорировать это поле",
        "matched_to_field": "Совпадает с полем:",
        "duplication_warning": "Это дублирующееся поле и его нельзя подтвердить. Пожалуйста, выберите другое поле.",
        "confirm_map_button": "Подтвердить сопоставление"
    },
    "reviewMaping": {
        "title": "Пожалуйста, просмотрите данные, сопоставленные с нашими полями. (Вы также можете редактировать значения данных здесь.)",
        "warning": "У вас есть одно или несколько отсутствующих обязательных полей или недопустимых значений. Пожалуйста, проверьте их, иначе эти строки не будут импортированы."
    },
    "valueMapping": {
        "user_mapping_title": "Сопоставление пользователей",
        "user_mapping_instruction": "Для сохранения назначений, лидеров и активности задач сопоставьте пользователей с пользователями Hyphen OI Pro. Если вы не сопоставите пользователей, данные не будут импортированы, так как им не будет найдено соответствие в Hyphen OI Pro.",
        "user_dropdown_text": "Выберите пользователя",
        "status_mapping_title": "Сопоставление статуса",
        "status_mapping_instruction": "Для поддержания согласованности рабочих процессов сопоставьте ваши статусы с существующими значениями в Hyphen OI Pro. Это поможет избежать ошибок в будущем.",
        "status_dropdown_text": "Выберите статус",
        "priority_mapping_title": "Сопоставление приоритетов",
        "priority_mapping_instruction": "Для поддержания согласованности рабочих процессов сопоставьте ваши приоритетные значения с существующими в Hyphen OI Pro. Это поможет избежать ошибок в будущем.",
        "priority_dropdown_text": "Выберите приоритет",
        "custom_field_mapping_title": "Сопоставление пользовательских полей",
        "custom_field_mapping_instruction": "Чтобы обеспечить совместимость, сопоставьте типы ваших пользовательских полей с существующими типами в Hyphen OI Pro. Это поможет избежать ошибок в будущем.",
        "custom_delimiters_quest": "ℹ️ Есть ли в ваших пользовательских полях разделители значений?"
    },
    "importMappingKeywords": {
        "task_id_description": "ID конкретной задачи.",
        "task_name_description": "Название задачи, обычно краткое описание.",
        "task_description_description": "Подробная информация о задаче.",
        "task_assignee_description": "Электронная почта назначенного сотрудника.",
        "task_parentId_description": "ID родительской задачи, к которой относится эта задача.",
        "task_leaderId_description": "ID пользователя, который руководит задачей.",
        "task_priority_description": "Уровень важности, присвоенный задаче.",
        "task_status_description": "Текущее состояние или прогресс выполнения задачи.",
        "task_start_date_description": "Дата начала задачи.",
        "task_due_date_description": "Дата, к которой задача должна быть выполнена."
    },
    "Affiliate": {
        "refer_earn": "Приглашайте и зарабатывайте",
        "unlimited": "Без ограничений",
        "invite_start_earning_cash_rewards": "Приглашайте друзей и начинайте зарабатывать денежные вознаграждения.",
        "your_referral_code": "Ваш реферальный код",
        "invite_spend_message": "С каждой покупки вашего друга вы будете получать {percentage}% от суммы в качестве вознаграждения.",
        "inviteText": "Пригласите друзей, поделившись этой ссылкой",
        "copy": "Копировать",
        "refferal_code_label": "Реферальный код",
        "refferal_code_placeholder": "Введите реферальный код",
        "invalid_refferal_model_title": "Ваш реферальный код недействителен",
        "invalid_refferal_model_confirm_text": "Да, создайте его!",
        "invalid_refferal_model_text": "Вы уверены, что хотите создать компанию?",
        "refferal_code_error": "Реферальный код недействителен"
    },
    "dashboardCard": {
        "tasks_by_assignee_bar_chart_description": "Отобразить столбчатую диаграмму ваших общих задач по исполнителю",
        "tasks_by_assignee_bar_chart_title": "Задачи по исполнителю",
        "task_list_description": "Создать представление списка, используя задачи из любого местоположения",
        "tasks_list_title": "Список задач",
        "tasks_by_assignee_stack_bar_chart_description": "Отобразить сгруппированную диаграмму ваших общих задач по исполнителю",
        "tasks_by_assignee_stack_bar_chart_title": "Задачи по исполнителю",
        "workload_by_status_stack_bar_chart_description": "Отобразить распределение ваших статусов по местоположениям",
        "workload_by_status_stack_bar_chart_title": "Нагрузка по статусу",
        "tasks_by_assignee_pie_chart_description": "Отобразить круговую диаграмму ваших общих задач по исполнителю",
        "tasks_by_assignee_pie_chart_title": "Задачи по исполнителю",
        "workload_by_status_pie_chart_description": "Отобразить круговую диаграмму использования ваших статусов по местоположениям",
        "workload_by_status_pie_chart_title": "Нагрузка по статусу",
        "workload_by_status_bar_chart_description": "Отобразить столбчатую диаграмму использования ваших статусов по местоположениям",
        "workload_by_status_bar_chart_title": "Нагрузка по статусу",
        "queue_list_title": "Список очереди",
        "queue_list_description": "Просмотр списка ваших задач вместе с их статусами.",
        "card_name": "название карточки",
        "location": "проект",
        "group_by": "группировать по",
        "show_assignees": "показать исполнителей",
        "include_subtasks": "включить подзадачи",
        "display_labels_as_percent": "отображать метки в процентах",
        "show_legend": "показать легенду",
        "show_Data_Labels": "показать метки данных",
        "select": "выбрать",
        "add_card": "Добавить карточку",
        "back": "Назад",
        "error_assignees": "Поле «показать исполнителей» обязательно для заполнения",
        "error_location": "Поле «местоположение» обязательно для заполнения",
        "empty_layout_container": "Ваша панель управления пуста. Нажмите 'Добавить карту', чтобы начать.",
        "status": "статус",
        "edit_card": "редактировать карточку",
        "calendar_card_title": "Календарь",
        "calendar_card_description": "Это календарный вид для задач",
        "measure": "мера",
        "calculation": "вычисление",
        "total_urgent_tasks": "Общее количество срочных задач",
        "total_urgent_tasks_description": "Отображение общего количества срочных задач по местоположению",
        "time_tracker": "Тайм-трекер",
        "time_estimate": "Оценка времени",
        "range": "Диапазон",
        "max": "Макс",
        "min": "Мин",
        "median": "Медиана",
        "average": "Среднее",
        "sum": "Сумма",
        "workload_estination_title": "Отчет о времени",
        "workload_estination_description": "Просмотр задач с отслеживаемым и оценочным временем.",
        "workload_only_estination_title": "Оценочное время",
        "workload_only_estination_description": "Просмотр оценочного времени.",
        "time_only_estination_title": "Зарегистрированное время",
        "time_only_estination_description": "Просмотр зарегистрированного времени.",
        "today": "Сегодня",
        "yesterday": "Вчера",
        "this_week": "На этой неделе",
        "last_week": "На прошлой неделе",
        "this_month": "В этом месяце",
        "last_month": "В прошлом месяце",
        "this_year": "В этом году",
        "last_30_days": "Последние 30 дней",
        "task": "Количество задач",
        "task_label": "Метка задачи",
        "both": "Показать оба",
        "manual_time": "Показывать только вручную введенное время",
        "track_time": "Показывать только отслеженное время",
        "logtype": "Журналы времени",
        "timerange": "Период времени",
        "priority": "Приоритет",
        "due_date": "Срок",
        "none": "Нет",
        "total_time_track_description": "Показать общее время отслеживания",
        "total_time_track_tasks": "Общее время отслеживания",
        "total_tasks_count_description": "Показать общее количество задач",
        "total_tasks_count": "Общее количество задач",
        "assignees": "Назначенные",
        "feature": "Функция",
        "workload": "Нагрузка",
        "time_tracking": "Отслеживание времени",
        "task_card": "Задачи",
        "Today": "Сегодня",
        "Yesterday": "Вчера",
        "Tomorrow": "Завтра",
        "This_week": "Эта неделя",
        "Next_week": "Следующая неделя",
        "Next_seven_days": "Следующие 7 дней",
        "Last_seven_days": "Последние 7 дней",
        "Last_month": "Прошлый месяц",
        "This_month": "Этот месяц",
        "Next_month": "Следующий месяц",
        "Date_range": "Диапазон дат",
        "me_mode": "я",
        "data": "Данные",
        "display": "Отобразить",
        "fields": "Поля"
    },
    "designationMapping": {
        "title": "Картирование Должностей",
        "description": "Пожалуйста, сопоставьте должности в вашем CSV с существующими должностями в Hyphen OI Pro."
    },
    "roleMapping": {
        "title": "Картирование Ролей",
        "description": "Пожалуйста, сопоставьте роли в вашем CSV с существующими ролями в Hyphen OI Pro."
    },
    "importUserKeywords": {
        "user_email_description": "Электронная почта пользователя",
        "user_role_description": "Роль или должность, назначенная пользователю в организации.",
        "user_designation_description": "Официальное наименование должности сотрудника в компании."
    },
    "userSelection": {
        "title": "Выбор Пользователей",
        "user_limit_error": "Достигнут максимальный лимит пользователей. Пожалуйста, обновите свой план для импорта большего количества пользователей.",
        "description": "Выберите всех пользователей, которых хотите импортировать.",
        "duplicate_email_error": "Этот Email уже существует в Hyphen OI Pro. Вы не можете его импортировать.",
        "invalid_email": "Этот Email недействителен. Пожалуйста, используйте действительный Email.",
        "invalid_fields": "У вас есть одно или несколько неверных полей. Пожалуйста, проверьте выделенные поля.",
        "user_limit_100": "Вы можете импортировать максимум 100 пользователей за раз."
    },
    "importUserButton": {
        "import_user_processing": "Ваши пользователи импортируются"
    },
    "timeForecastingReport": {
        "project_name": "Название проекта",
        "project_status": "Статус проекта",
        "start_date": "Дата начала",
        "due_date": "Срок сдачи",
        "last_logged_date": "Последняя дата записи",
        "budget": "Бюджет",
        "actual": "Фактически",
        "forecast": "Прогноз",
        "estimated_hours": "Оценочные часы",
        "logged_hours": "Зарегистрированные часы",
        "remaining_hours": "Оставшиеся часы",
        "overdue_hours": "Просроченные часы",
        "estimated_time_to_complete": "Оценочное время завершения",
        "estimated_complition_date": "Предполагаемая дата завершения",
        "show_legends": "Показать легенду",
        "show_data_labels": "Показать подписи к данным",
        "report_type": "Тип отчета"
    }
}